<template>
  <div class='content'>
    <div v-if="!showCreateEnvelope">
      <div class='col-md-12 no-pad'>
        <!-- //- TOP NAV -->
        <ed-title-nav class="title-nav" :title="divName ? `Account: ${divName}` : 'Account: Loading...'">
          <span slot='action' v-if="hasAccountPermission('EvedPayCardViewReconcileClose') || hasAccountPermission('EvedPayCardAdministrator')">
            <router-link :to="{ params: { namespace: 'd', page: 'Programs', section: '>Card', action: undefined } }">
              <i class="fa fa-long-arrow-left"></i>
              <span> &nbsp; {{ $t('BACK') + ' ' + $t('TO') + ' ' + $t('EVEDPAY') + ' ' + $t('CARDS') + ' ' + $t($route.query['back-to']) }}</span>
            </router-link>
          </span>
          <span slot="tabs">
            <ed-select v-if="divisions.length > 1"
                       class="custom-ed-select"
                       @input="(o) => {redirectCardholder(o.AccountId), selectDivision = []}"
                       :placeholder="'Change Account'"
                       :options="divisions"
                       v-model="selectDivision"
                       label="DivisionName"
                       track-by="DivisionId"
                       @open="getUserDivisions"
                       name="supplier_user" />
          </span>
        </ed-title-nav>
      </div>

      <!-- //- PAGE -->
      <div class='container-fluid'>
        <ed-section class='active clear white'>
          <div class='col-md-12 no-pad'>

            <!-- //- ACCOUNT TOTALS -->
            <div class="col-md-12 no-pad" style="display: flex; align-items: center; gap: 5px;">
              <label v-if="hasAccountPermission('EvedPayCardViewReconcileClose') || hasAccountPermission('EvedPayCardAdministrator')">
                <strong>EvedPay Card Account</strong>
              </label>
              <AddFunding v-if="hasAccountPermission('EvedPayCardAdministrator')"
                          style="margin-left: auto;"
                          @success="getAccountData()"
                          :accountId="account.Id" />
              <ed-button v-if="hasAccountPermission('EvedPayCardAdministrator')" button-class="btn btn-actionbar" @click="() => {accountRefillSettings.Visible = true}">
                Refill Settings
              </ed-button>
            </div>
            <!--<CloseAccount v-if="hasAccountPermission('EvedPayCardViewReconcileClose') || hasAccountPermission('EvedPayCardAdministrator')"
  @success="getAccountData()"
  :accountId="account.Id"
  :balance="account.Available"
  :division="division" />-->
            <div class='clear'></div>
            <div class="overview col-md-12 no-pad" v-if="hasAccountPermission('EvedPayCardViewReconcileClose') || hasAccountPermission('EvedPayCardAdministrator')">
              <ed-card class="overview-card" footer-button="false">
                <div v-if='!hasData' slot="body" class="soft-text loading-text">
                  <span />Loading account summary ...
                </div>
                <div v-if='hasData' style="margin-top: -20px !important;" slot="body" class="soft-text">
                  <div class="custom-col">
                    <div style="font-weight: bold; font-size: 1.1em; margin-bottom: 10px;">
                      Account Summary
                    </div>
                  </div>
                  <div class="custom-col">
                    <div>Funded</div>
                    <div>
                      <strong>
                        <v-money currency="USD" locale="en">{{ account.Funded }}</v-money>
                      </strong>
                    </div>
                  </div>

                  <div class="custom-col">
                    <div>
                      Allocated to cards
                      <a style="margin-bottom: 10px;" v-tooltip="'Includes fees for Rush Orders'">
                        <i class="fas fa-info-circle" :style="{ color: '#808080' }"></i>
                      </a>
                    </div>
                    <div>
                      <strong>
                        <v-money currency="USD" locale="en">{{ account.Allocated }}</v-money>
                      </strong>
                    </div>
                  </div>

                  <div class="custom-col">
                    <div>Available</div>
                    <div>
                      <strong>
                        <v-money currency="USD" locale="en">{{ account.Available }}</v-money>
                      </strong>
                    </div>
                  </div>

                  <div class="custom-col">
                    <div>Pending Funding</div>
                    <div>
                      <strong>
                        <v-money currency="USD" locale="en">{{ account.Pending }}</v-money>
                      </strong>
                    </div>
                  </div>
                  <br />
                </div>
              </ed-card>
            </div>

            <div class="col-md-12 no-pad" style="display: flex; align-items: center; gap: 5px;">
              <label>
                <strong>EvedPay Cards</strong>
              </label>
              <AddCard v-if="hasAccountPermission('EvedPayCardAdministrator')"
                       style="margin-left: auto;"
                       @success="handleCardAdditionSuccess"
                       :divisionId="account.DivisionId"
                       :accountId="selectedAccountId"
                       :account="account"
                       :accountSettings="accountSettings"/>
              <ed-button class="btn btn-actionbar"
                         v-if="hasAccountPermission('EvedPayCardAdministrator')"
                         :disabled="requestPhysicalBatchActionDisabledReason('requestPhysicalBatch')"
                         v-tooltip="requestPhysicalBatchActionDisabledReason('requestPhysicalBatch')"
                         @click="() => {
                          showRequestPhysicalBatchOpen.showModal = true;
                          showRequestPhysicalBatchOpen.dataFlag = 'filtered';
                          showRequestPhysicalBatchOpen.data = filteredPhysicalCards;
                        }">
                REQUEST PHYSICAL BATCH
              </ed-button>
            </div>
              <div class='clear'></div>

              <div v-if="hasData && Number(account.Funded) === 0" class="prefunding-alert">
                <div class="prefunding-alert__title">Pre-funding Card Limit</div>
                <div class="prefunding-alert__body">Up to 30 cards can be added to this account prior to funding.</div>
              </div>

              <!-- //- CARDS LIST -->
              <div class="card-container">
                <ed-card v-if="card" :class="cardClass(card)" footer-button="false" v-for="(card, i) in cardsList" :key="i">
                  <div slot="body">
                    <div v-if="card.Id">
                      <template v-if="card.CardStatus === 'Pending Approval' && card.IsApproved === false && card.IsRejected === false && card.WaitingApproval !== null">
                        <div class="badge" style="background-color: #6B04B7; ">
                          <p><i class="fas fa-credit-card" />  Add Card Request</p>
                        </div>
                        <br />
                        <div>
                          {{ formatCardHolderLine(card) }}
                        </div>
                        <div class="badge" :class="{'na': !card.CardStatus, 'Active': card.CardStatus === 'Active', 'Locked': card.CardStatus === 'Locked', 'Closed': card.CardStatus === 'Closed', 'Expired': card.CardStatus === 'Expired', 'PendingApproval': card.CardStatus === 'Pending Approval', 'Inactive': card.CardStatus === 'Inactive'}">
                          {{ card.CardStatus || 'N/A' }}
                        </div>
                        <a href="javascript:;" style="margin-bottom: 10px;" v-tooltip="'Users that need to approve the card.'" @click="handleButtonClick(card.Id, false)">
                          <i class="fas fa-question-circle" :style="{ color: '#DCDC00' }"></i>
                        </a>
                        <hr />
                        <!-- PRODUCTDEV-5573: a pending pool card draws on the shared account via Auto Card
                             Funding - it has no Initial Load / Refill, so show the requested Daily Spend Limit
                             instead (the pool analogue of the per-card requested load). -->
                        <div style="display: flex; justify-content: space-between;" v-if="isPoolFunding(card)">
                          <div style="flex: 1;">Daily Spend Limit</div>
                          <span v-if="card.DailySpendLimit === null || card.DailySpendLimit === undefined">N/A</span>
                          <v-money v-else currency="USD" locale="en">{{ card.DailySpendLimit }}</v-money>
                        </div>
                        <div style="display: flex; justify-content: space-between;" v-if="!isPoolFunding(card)">
                          <div style="flex: 1;">Initial Load</div>
                          <v-money currency="USD" locale="en">{{ card.InitialLoad }}</v-money>
                        </div>
                        <div style="display: flex; justify-content: space-between;" v-if="!isPoolFunding(card)">
                          <div style="flex: 1;">Refill Amount</div>
                          <v-money currency="USD" locale="en">{{ card.RefillSettings.RefillAmount }}</v-money>
                        </div>
                        <div style="display: flex; justify-content: space-between;" v-if="!isPoolFunding(card)">
                          <div style="flex: 1;">Refill Threshold</div>
                          <v-money currency="USD" locale="en">{{ card.RefillSettings.RefillThreshold }}</v-money>
                        </div>
                        <div style="text-align: center; margin-top: 50px;" v-if="card.ShowApprovalButtons === true">
                          <ed-button button-class="btn btn-actionbar alt col-md-12" style="margin-bottom: 10px;" @click="() => approveOrReject(card.Id, 'approve')">
                            Approve
                          </ed-button>
                          <RejectCard :card="card" @success="cardId => { refreshCardWithDetails(cardId); getAccountData(); }" />
                        </div>
                        <div style="text-align: center; margin-top: 50px;" v-if="card.ShowApprovalButtons === false && card.CardStatus === 'Pending Approval'">
                          <ed-button button-class="btn btn-actionbar col-md-12"
                                     :disabled="disabledResendButtons[card.Id]"
                                     @click="() => resendCardApprovalEmail(card.Id)">
                            RESEND APPROVAL
                          </ed-button>
                        </div>
                      </template>
                      <template v-else>
                        <!-- PRODUCTDEV-5908: main card-info column. cardApprovalColClass keeps it on the same row
                             as any pending-approval sections (Funding / Refill Settings / Daily Spend Limit) by
                             splitting the 12-column grid evenly across the info column plus the active sections. -->
                        <div :class="cardApprovalColClass(card)">
                          <div v-if="hasData && card.CardStatus !== 'Processing'">
                            <CardSettings :card="card" :account="account" :accountSettings="accountSettings" :division="division" slot="body" @success="handleSuccess"/>
                          </div>
                          **** **** **** {{card.CardNumber}}
                          <div>
                            {{ formatCardHolderLine(card) }}
                          </div>
                          <div>
                            Expires {{ formatDate(card.ExpirationDate) }}
                          </div>
                          <div class="badge" :class="{'na': !card.CardStatus, 'Active': card.CardStatus === 'Active', 'Locked': card.CardStatus === 'Locked', 'Closed': card.CardStatus === 'Closed', 'Expired': card.CardStatus === 'Expired', 'Rejected': card.CardStatus === 'Rejected', 'Declined': card.CardStatus === 'Declined', 'Inactive': card.CardStatus === 'Inactive'}">
                            {{ card.CardStatus === 'Rejected' ? 'Declined' : (card.CardStatus || 'N/A') }}
                          </div>
                          <a v-if="card.RejectReason" href="javascript:;" style="margin-bottom: 10px;" v-tooltip="'Click to see decline reason'" @click="handleButtonClickReject(card.Id)">
                            <i class="fas fa-info-circle" :style="{ color: '#E70404' }"></i>
                          </a>
                          <hr />
                          <div style="font-style: italic; font-weight: lighter;" v-if="card.ReconciliationDate">
                            Reconciled up to {{ card.FormattedReconciliationDate }}
                          </div>
                          <hr v-if="card.ReconciliationDate" />
                          <div style="display: flex; justify-content: space-between;" v-if="!isPoolFunding(card)">
                            <div style="flex: 1;">Initial Load</div>
                            <v-money currency="USD" locale="en">{{ card.InitialLoad }}</v-money>
                          </div>
                          <div style="display: flex; justify-content: space-between;" v-if="!isPoolFunding(card)">
                            <div style="flex: 1;">Refills</div>
                            <v-money currency="USD" locale="en">{{ card.Refills }}</v-money>
                          </div>
                          <div style="display: flex; justify-content: space-between;" v-if="!isPoolFunding(card)">
                            <div style="flex: 1;">Pending Request</div>
                            <v-money currency="USD" locale="en">{{ card.PendingRequest }}</v-money>
                          </div>
                          <!-- PRODUCTDEV-5573 (pool funding tile, Ned-confirmed layout): Daily Spend Limit,
                               Today's Spend, Remaining (Daily Spend Limit minus Today's Spend; N/A when no
                               limit is set), and Total Spent (the card's overall spend). A pool card has no
                               individual balance - it draws on the shared PEX account via Auto Card Funding -
                               so Initial Load / Refills / Pending Request / Spent / Balance / Return to Account
                               are all hidden for pool. -->
                          <div style="display: flex; justify-content: space-between;" v-if="isPoolFunding(card)">
                            <div style="flex: 1;">Daily Spend Limit</div>
                            <span v-if="card.DailySpendLimit === null || card.DailySpendLimit === undefined">N/A</span>
                            <v-money v-else currency="USD" locale="en">{{ card.DailySpendLimit }}</v-money>
                          </div>
                          <div style="display: flex; justify-content: space-between;" v-if="isPoolFunding(card)">
                            <div style="flex: 1;">Today's Spend</div>
                            <v-money currency="USD" locale="en">{{ card.TodaysSpend }}</v-money>
                          </div>
                          <div style="display: flex; justify-content: space-between;" v-if="isPoolFunding(card)">
                            <div style="flex: 1;">Remaining</div>
                            <span v-if="card.Remaining === null || card.Remaining === undefined">N/A</span>
                            <v-money v-else currency="USD" locale="en">{{ card.Remaining }}</v-money>
                          </div>
                          <div style="display: flex; justify-content: space-between;" v-if="isPoolFunding(card)">
                            <div style="flex: 1;">Total Spent</div>
                            <v-money currency="USD" locale="en">{{ card.Spent }}</v-money>
                          </div>
                          <div style="display: flex; justify-content: space-between;" v-if="!isPoolFunding(card)">
                            <div style="flex: 1;">Spent</div>
                            <v-money currency="USD" locale="en">{{ card.Spent }}</v-money>
                          </div>
                          <div style="display: flex; justify-content: space-between;" v-if="!isPoolFunding(card)">
                            <div style="flex: 1;"><strong>Balance</strong></div>
                            <strong><v-money currency="USD" locale="en">{{ card.Balance }}</v-money></strong>
                          </div>
                          <div style="display: flex; justify-content: space-between;" v-if="!isPoolFunding(card)">
                            <div style="flex: 1;">Return to Account</div>
                            <v-money currency="USD" locale="en">{{ card.Returned }}</v-money>
                          </div>
                        </div>
                        <div :class="cardApprovalColClass(card)" class="middleLine" v-if="card.PendingRequest > 0">
                          <div class="badge" style="background-color: #6B04B7; ">
                            <p><i class="fas fa-credit-card" />  Funds Request</p>
                          </div>
                          <br />
                          **** **** **** {{card.CardNumber}}
                          <div>
                            {{ formatCardHolderLine(card) }}
                          </div>
                          <div>
                            Expires {{ formatDate(card.ExpirationDate) }}
                          </div>
                          <div v-if="(card.PendingRequest > account.Available && card.ShowApprovalButtons === false) || (card.PendingRequest <= account.Available && (card.ShowApprovalButtons === true || card.ShowApprovalButtons === false))" class="badge" :class="{'PendingApproval': 'Pending Approval'}">
                            {{ 'Pending Approval' }}
                          </div>
                          <a href="javascript:;" style="margin-bottom: 10px;" v-tooltip="'Users that need to approve the card.'" @click="handleButtonClick(card.Id, false)" v-if="(card.PendingRequest > account.Available && card.ShowApprovalButtons === false) || (card.PendingRequest <= account.Available && (card.ShowApprovalButtons === true || card.ShowApprovalButtons === false))">
                            <i class="fas fa-question-circle" :style="{ color: '#DCDC00' }"></i>
                          </a>
                          <div v-if="card.PendingRequest > account.Available  && card.ShowApprovalButtons === true">
                            <i class="fas fa-exclamation-triangle" :style="{ color: '#DC0000' }"></i>&nbsp;<span style="font-style: italic;">Insufficient Funds</span>
                          </div>
                          <hr />
                          <div style="display: flex; justify-content: space-between;">
                            <div style="flex: 1;">Funds Request</div>
                            <v-money currency="USD" locale="en">{{ card.PendingRequest }}</v-money>
                          </div>
                          <br />
                          <hr />
                          <div style="text-align: center; margin-top: 50px;" v-if="card.ShowApprovalButtons === true">
                            <ed-button button-class="btn btn-actionbar alt col-md-12"
                                       style="margin-bottom: 10px;"
                                       @click="() => approveOrRejectEvedPayCardFunding(card.Id, 'approve')"
                                       :disabled="cardActionDisabled('approveValidation', card)"
                                       v-tooltip="actionDisabledReason('approveValidation', card)">
                              Approve
                            </ed-button>
                            <RejectCardFunding :card="card" @success="() => refreshCardWithDetails(card.Id)" />
                          </div>
                          <div style="text-align: center; margin-top: 50px;" v-if="card.ShowApprovalButtons === false && card.PendingRequest > 0">
                            <ed-button button-class="btn btn-actionbar col-md-12"
                                       :disabled="disabledResendButtons[`${card.Id}-funding`]"
                                       @click="() => resendCardFundingApprovalEmail(card.Id)">
                              RESEND APPROVAL
                            </ed-button>
                          </div>
                          <div v-if="card.PendingRequest > account.Available && card.ShowApprovalButtons === false">
                            <i class="fas fa-exclamation-triangle" :style="{ color: '#DC0000' }"></i>&nbsp;<span style="font-style: italic;">Insufficient Funds</span>
                          </div>
                        </div>
                        <div :class="cardApprovalColClass(card)" class="middleLine" v-if="card.RefillSettings.HasRefillRequest">
                          <div class="badge" style="background-color: #6B04B7; ">
                            <p><i class="fas fa-credit-card" />  Refill Settings Request</p>
                          </div>
                          <br />
                          **** **** **** {{card.CardNumber}}
                          <div>
                            {{ formatCardHolderLine(card) }}
                          </div>
                          <div>
                            Expires {{ formatDate(card.ExpirationDate) }}
                          </div>
                          <div class="badge" :class="{'PendingApproval': 'Pending Approval'}">
                            {{ 'Pending Approval' }}
                          </div>
                          <a href="javascript:;" style="margin-bottom: 10px;" v-tooltip="'Users that need to approve the card.'" @click="handleButtonClick(card.Id, true)">
                            <i class="fas fa-question-circle" :style="{ color: '#DCDC00' }"></i>
                          </a>
                          <hr />
                          <div style="display: flex; justify-content: space-between;">
                            <div style="flex: 1;">Refill Amount</div>
                            <v-money currency="USD" locale="en">{{ card.RefillSettings.RefillAmount }}</v-money>
                          </div>
                          <div style="display: flex; justify-content: space-between;">
                            <div style="flex: 1;">Refill Threshold</div>
                            <v-money currency="USD" locale="en">{{ card.RefillSettings.RefillThreshold }}</v-money>
                          </div>
                          <hr />
                          <div style="text-align: center; margin-top: 50px;" v-if="card.ShowApprovalButtons === true">
                            <ed-button button-class="btn btn-actionbar alt col-md-12"
                                       style="margin-bottom: 10px;"
                                       @click="() => approveOrRejectEvedPayCardRefill(card.Id, 'approve')">
                              Approve
                            </ed-button>
                            <RejectCardRefill :card="card" @success="() => refreshCardWithDetails(card.Id)" />
                          </div>
                          <div style="text-align: center; margin-top: 50px;" v-if="card.ShowApprovalButtons === false && card.RefillSettings.HasRefillRequest">
                            <ed-button button-class="btn btn-actionbar col-md-12"
                                       :disabled="disabledResendButtons[`${card.Id}-refill`]"
                                       @click="() => resendCardRefillApprovalEmail(card.Id)">
                              RESEND APPROVAL
                            </ed-button>
                          </div>
                        </div>
                        <!-- PRODUCTDEV-5884 (pool funding): pending Daily Spend Limit approval section (mirror of Refill Settings Request) -->
                        <div :class="cardApprovalColClass(card)" class="middleLine" v-if="card.HasDailySpendLimitRequest">
                          <div class="badge" style="background-color: #6B04B7; ">
                            <p><i class="fas fa-credit-card" />  Daily Spend Limit Request</p>
                          </div>
                          <br />
                          **** **** **** {{card.CardNumber}}
                          <div>
                            {{ formatCardHolderLine(card) }}
                          </div>
                          <div>
                            Expires {{ formatDate(card.ExpirationDate) }}
                          </div>
                          <div class="badge" :class="{'PendingApproval': 'Pending Approval'}">
                            {{ 'Pending Approval' }}
                          </div>
                          <a href="javascript:;" style="margin-bottom: 10px;" v-tooltip="'Users that need to approve the card.'" @click="handleButtonClick(card.Id, true)">
                            <i class="fas fa-question-circle" :style="{ color: '#DCDC00' }"></i>
                          </a>
                          <hr />
                          <div style="display: flex; justify-content: space-between;">
                            <div style="flex: 1;">Daily Spend Limit</div>
                            <span v-if="card.PendingDailySpendLimit === null || card.PendingDailySpendLimit === undefined">None</span>
                            <v-money v-else currency="USD" locale="en">{{ card.PendingDailySpendLimit }}</v-money>
                          </div>
                          <hr />
                          <div style="text-align: center; margin-top: 50px;" v-if="card.ShowDailySpendLimitApprovalButtons === true">
                            <ed-button button-class="btn btn-actionbar alt col-md-12"
                                       style="margin-bottom: 10px;"
                                       @click="() => approveOrRejectEvedPayCardDailySpendLimit(card.Id)">
                              Approve
                            </ed-button>
                            <RejectCardDailySpendLimit :card="card" @success="() => refreshCardWithDetails(card.Id)" />
                          </div>
                          <div style="text-align: center; margin-top: 50px;" v-if="card.ShowDailySpendLimitApprovalButtons === false && card.HasDailySpendLimitRequest">
                            <ed-button button-class="btn btn-actionbar col-md-12"
                                       :disabled="disabledResendButtons[`${card.Id}-dsl`]"
                                       @click="() => resendCardDailySpendLimitApprovalEmail(card.Id)">
                              RESEND APPROVAL
                            </ed-button>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div v-else class="empty-holder">
                      <i class="fas fa-credit-card" />
                      <span>
                        <br />
                        <p>No cards have been created for this account.</p>
                      </span>
                    </div>
                  </div>
                </ed-card>
              </div>
              <div class='clear'></div>
              <div class="overview col-md-12 no-pad" v-if="hasAccountPermission('EvedPayCardViewReconcileClose') || hasAccountPermission('EvedPayCardAdministrator')">
              <ed-card class="overview-card" footer-button="false">
                <div v-if='!hasData' slot="body" class="soft-text loading-text">
                  <span />Loading transactions summary ...
                </div>
                <div v-if='hasData' style="margin-top: -20px !important;" slot="body" class="soft-text">
                  <div class="custom-col">
                    <div style="font-weight: bold; font-size: 1.1em; margin-bottom: 10px;">
                      Transactions Summary
                    </div>
                  </div>
                  
                  <div class="custom-col">
                    <div>
                      Total Spent
                      <a style="margin-bottom: 10px;" v-tooltip="'Includes fees for Rush Orders'">
                        <i class="fas fa-info-circle" :style="{ color: '#808080' }"></i>
                      </a>
                    </div>
                    <div>
                      <strong>
                        <v-money currency="USD" locale="en">{{ account.Spent }}</v-money>
                      </strong>
                    </div>
                  </div>

                  <div class="custom-col">
                    <div>
                      Open Transactions
                      <a style="margin-bottom: 10px;" v-tooltip="'Open and Pending transactions'">
                        <i class="fas fa-info-circle" :style="{ color: '#808080' }"></i>
                      </a>
                    </div>
                    <div>
                      <strong>
                        <v-money currency="USD" locale="en">{{ account.OpenTransactionsAmount }}</v-money>
                      </strong>
                    </div>
                  </div>

                  <div class="custom-col">
                    <div>
                      Pending Envelopes
                      <a style="margin-bottom: 10px;" v-tooltip="'Envelopes pending approval and pending export'">
                        <i class="fas fa-info-circle" :style="{ color: '#808080' }"></i>
                      </a>
                    </div>
                    <div>
                      <strong>
                        <v-money currency="USD" locale="en">{{ account.PendingEnvelopesAmount }}</v-money>
                      </strong>
                    </div>
                  </div>
                  <br />
                </div>
              </ed-card>
            </div>
              
              <button @click="showTransactions" class="custom-button" :class="{ 'active': showTransactionsTab }">Transactions</button>
              <span class="divider">|</span>
              <button @click="showEnvelopes" class="custom-button" :class="{ 'active': showEnvelopesTab }">Envelopes</button>
              <span class="divider">|</span>
              <button @click="showCardHistory" class="custom-button" :class="{ 'active': showCardHistoryTab }">Card History</button>
              <span class="divider" v-if="hasAccountPermission('EvedPayCardAdministrator') || hasAccountPermission('EvedPayCardViewReconcileClose')">|</span>
              <button v-if="hasAccountPermission('EvedPayCardAdministrator') || hasAccountPermission('EvedPayCardViewReconcileClose')"
                      @click="showCards"
                      class="custom-button"
                      :class="{ 'active': showCardsTab }">
                Cards
              </button>
              <span class="divider" v-if="hasAccountPermission('EvedPayCardAdministrator')">|</span>
              <button v-if="hasAccountPermission('EvedPayCardAdministrator')"
                      @click="showAccountStatements"
                      class="custom-button"
                      :class="{ 'active': showAccountStatementsTab }">
                Statements
              </button>
              <div class="clear"></div>
              <!-- TRANSACTIONS -->
              <div v-if="showTransactionsTab">
                <Grid :name="$t('EvedPay Cards Transactions')"
                      desc="EvedPay Cards Transactions"
                      :model="modelTransactionsAccount"
                      ref="grid"
                      :search="true"
                      :resizing="false"
                      layout="frame"
                      :endpoint="api.$.evedpaycard.transactions"
                      :sort="sort"
                      :views="false"
                      :row-classes="rowClasses"
                      footer
                      legacy
                      alias="EvedPayCardsTransactions"
                      @selectedRows="rowSelected"
                      :no-tooltip-fields="noTooltipFields"
                      :filter="filter"
                      :key="gridTabKey"
                      totals>
                  <span slot="additionalButtons">
                    <!-- PRODUCTDEV-5788 — account-scoped table: show only if the feature flag is on AND
                         this account's division is scan-enabled (hidden when it's "No Receipt Capture"). -->
                    <ed-button class="btn btn-actionbar"
                               v-if="receiptScanEnabled && accountScanEnabled"
                               :disabled="uploadingReceipt"
                               @click="openReceiptUpload">
                      SUBMIT RECEIPT
                    </ed-button>
                    <input type="file"
                           ref="receiptUploadInput"
                           accept="image/*,application/pdf"
                           @change="handleReceiptFileSelected"
                           style="display:none">
                    <ed-button class="btn btn-actionbar"
                               :disabled="cardActionDisabled('createEnvelope')"
                               v-tooltip="actionDisabledReason('createEnvelope')"
                               @click="createEnvelope">
                      CREATE ENVELOPE
                    </ed-button>
                    <ed-button class="btn btn-actionbar"
                               :disabled="cardActionDisabled('reconcile')"
                               v-tooltip="actionDisabledReason('reconcile')"
                               @click="showModal(showReconcile)">
                      RECONCILE
                    </ed-button>
                  </span>
                </Grid>
              </div>

              <!-- ENVELOPES -->
              <div v-if="showEnvelopesTab">
                <grid :name="$t('EvedPay Cards Envelopes')"
                      desc="EvedPay Cards Envelopes"
                      :model="modelEnvelopes"
                      :search="true"
                      :sort="sortEnvelopes"
                      :resizing="false"
                      layout="frame"
                      ref="grid"
                      :endpoint="api.$.evedpaycard.envelopes"
                      :views="false"
                      :row-classes="rowClasses"
                      footer
                      totals
                      legacy
                      alias="EvedPayCardsEnvelopes"
                      @selectedRows="rowSelected"
                      :no-tooltip-fields="noTooltipFields"
                      :filter="filter"
                      :key="gridTabKey">
                  <span slot="additionalButtons">
                    <ed-button class="btn btn-actionbar"
                               v-if="showApproveButton"
                               :disabled="cardActionDisabled('approve')"
                               v-tooltip="actionDisabledReason('approve')"
                               @click="showApproveDialog = true">
                      Approve
                    </ed-button>
                    <RejectEnvelope v-if="showRejectButton"
                                    :disabled="cardActionDisabled('reject')"
                                    v-tooltip="actionDisabledReason('reject')"
                                    :selected-rows="selectedRows"
                                    @success="refresh" />
                    <ed-button v-if="hasAccountPermission('EvedPayCardAdministrator') || hasAccountPermission('EvedPayCardViewReconcileClose')"
                               button-class="btn btn-actionbar"
                               @click="createAPFile"
                               :disabled="envelopeActionDisabledReason('createAPFile')"
                               v-tooltip="envelopeActionDisabledReason('createAPFile')">
                      CREATE AP FILE
                    </ed-button>                    
                    <ed-button button-class="btn btn-actionbar"
                               @click="exportEnvelope"
                               :disabled="envelopeActionDisabledReason('exportEnvelope')"
                               v-tooltip="envelopeActionDisabledReason('exportEnvelope')">
                      EXPORT ENVELOPE
                    </ed-button>
                    <ed-button button-class="btn btn-actionbar"
                      @click="pushToAccountingSystem"
                      :disabled="envelopeActionDisabledReason('pushToAccountingSystemAction')"
                      v-tooltip="envelopeActionDisabledReason('pushToAccountingSystemAction')">
                      PUSH TO PSL+
                    </ed-button>
                    <AddTransactionNumber v-if="hasAccountPermission('EvedPayCardAdministrator')"
                                          :selected-rows="selectedRows"
                                          :disabled="envelopeActionDisabled('addTransactionNumber')"
                                          v-tooltip="envelopeActionDisabledReason('addTransactionNumber')"
                                          @success="refresh" />
                  </span>
                </grid>
              </div>

              <!-- CARD HISTORY -->
              <div v-if="showCardHistoryTab">
                <Grid :name="$t('EvedPay Cards History')"
                      desc="EvedPay Cards History"
                      :model="modelCardHistory"
                      :search="true"
                      :resizing="false"
                      layout="frame"
                      ref="grid"
                      :endpoint="api.$.evedpaycard.history"
                      :sort="sortHistory"
                      :views="false"
                      footer
                      legacy
                      alias="EvedPayCardsHistory"
                      :filter="filterHistory"
                      :key="gridTabKey"
                      :checkboxes="false"
                      fit-columns>
                </Grid>
              </div>

              <!-- CARDS -->
              <div v-if="showCardsTab">
                <grid :name="$t('EvedPay Cards')"
                      desc="EvedPay Cards"
                      :model="modelCardsAccount"
                      search=true
                      :sort="sortCards"
                      :resizing="false"
                      layout="frame"
                      :endpoint="api.$.evedpaycard.cards"
                      :views="false"
                      alias="EvedPayCards"
                      legacy
                      footer
                      totals
                      ref="grid"
                      :key="gridTabKey"
                      @selectedRows="rowSelected"
                      :filter="filterCards">
                  <span slot="additionalButtons">
                    <ed-button class="btn btn-actionbar"
                               v-if="hasAccountPermission('EvedPayCardAdministrator') && !accountSettings.IsPoolFunding"
                               :ids="selectedRows"
                               :disabled="cardActionDisabled('addFunds')"
                               v-tooltip="actionDisabledReason('addFunds')"
                               @click="() => {showAddFunds = true}">
                      Add Funds
                    </ed-button>
                    <ed-button class="btn btn-actionbar"
                               v-if="hasAccountPermission('EvedPayCardAdministrator')"
                               :ids="selectedRows"
                               :disabled="cardActionDisabled('additionalUsers')"
                               v-tooltip="actionDisabledReason('additionalUsers')"
                               @click="() => {showCardAdditionalUsers = true}">
                      Additional Users
                    </ed-button>
                    <ed-button class="btn btn-actionbar"
                               v-if="hasAccountPermission('EvedPayCardAdministrator') && !accountSettings.IsPoolFunding"
                               :ids="selectedRows"
                               :disabled="cardActionDisabled('returnFunds')"
                               v-tooltip="actionDisabledReason('returnFunds')"
                               @click="() => {showReturnFundsToAccount = true}">
                      Return Funds to Account
                    </ed-button>
                    <ed-button class="btn btn-actionbar"
                               v-if="hasAccountPermission('EvedPayCardAdministrator') && !accountSettings.IsPoolFunding"
                               :ids="selectedRows"
                               :disabled="cardActionDisabled('refillSettings')"
                               v-tooltip="actionDisabledReason('refillSettings')"
                               @click="() => { isRefillOpen.showModal = true }">
                      Refill Settings
                    </ed-button>
                    <ed-button class="btn btn-actionbar"
                               v-if="hasAccountPermission('EvedPayCardAdministrator') && accountSettings.IsPoolFunding"
                               :ids="selectedRows"
                               :disabled="cardActionDisabled('dailySpendLimit')"
                               v-tooltip="actionDisabledReason('dailySpendLimit')"
                               @click="() => { isDailySpendLimitOpen.showModal = true }">
                      Daily Spend Limit
                    </ed-button>
                    <ed-button class="btn btn-actionbar"
                      :ids="selectedRows"
                      :disabled="cardActionDisabled('editAccountingSystemSettings')"
                      v-tooltip="actionDisabledReason('editAccountingSystemSettings')"
                      @success="refresh"
                      @click="() => { showAccountingSystemSettings = true }">
                      PSL+ Settings
                    </ed-button>                        
                    <ed-button class="btn btn-actionbar"
                               v-if="hasAccountPermission('EvedPayCardAdministrator')"
                               :ids="selectedRows"
                               :disabled="cardActionDisabled('holdActivity')"
                               v-tooltip="actionDisabledReason('holdActivity')"
                               @click="lockCard">
                      {{ lockUnlockButtonText }}
                    </ed-button>
                    <ed-button class="btn btn-actionbar"
                               v-if="hasAccountPermission('EvedPayCardAdministrator')"
                               :ids="selectedRows"
                               :disabled="cardActionDisabled('reportLostStolen')"
                               v-tooltip="actionDisabledReason('reportLostStolen')"
                               @click="lostStolen">
                      Report Lost or Stolen
                    </ed-button>
                    <ed-button class="btn btn-actionbar"
                               v-if="hasAccountPermission('EvedPayCardAdministrator') || hasAccountPermission('EvedPayCardViewReconcileClose')"
                               :id="selectedRows"
                               :disabled="cardActionDisabled('showCardNumber')"
                               v-tooltip="actionDisabledReason('showCardNumber')"
                               @click="() => {showShowCardNumber = true}">
                      Card Number
                    </ed-button>
                    <ed-button class="btn btn-actionbar"
                               v-if="hasAccountPermission('EvedPayCardAdministrator')"
                               :disabled="cardActionDisabled('requestPhysicalCard')"
                               v-tooltip="actionDisabledReason('requestPhysicalCard')"
                               @click="() => {
                                showRequestPhysicalBatchOpen.showModal = true;
                                showRequestPhysicalBatchOpen.dataFlag = 'selected';
                                showRequestPhysicalBatchOpen.data = selectedRows;
                              }">
                      REQUEST PHYSICAL BATCH
                    </ed-button>
                    <ed-button class="btn btn-actionbar"
                               v-if="hasAccountPermission('EvedPayCardViewReconcileClose')"
                               :ids="selectedRows"
                               :disabled="cardActionDisabled('close')"
                               v-tooltip="actionDisabledReason('close')"
                               @click="closeCard">
                      Close Card
                    </ed-button>
                    <ed-button class="btn btn-actionbar"
                               v-if="showApproveButton && selectedRows.length"
                               :disabled="cardActionDisabled('approve')"
                               v-tooltip="actionDisabledReason('approve')"
                               @click="showApproveDialog = true">
                      Approve
                    </ed-button>
                    <RejectCard v-if="showRejectButton && selectedRows.length"
                                :disabled="cardActionDisabled('reject')"
                                v-tooltip="actionDisabledReason('reject')"
                                :selected-rows="selectedRows"
                                :button-class="getButtonClass()"
                                @success="cardId => refreshCardWithDetails(cardId)" />
                  </span>
                </grid>
              </div>

              <!-- ACCOUNT STATEMENTS -->
              <div v-if="showAccountStatementsTab">
                <Grid :name="$t('EvedPay Cards Account Statements')"
                      desc="EvedPay Cards Account Statements"
                      :model="modelAccountStatements"
                      :search="true"
                      :resizing="false"
                      layout="frame"
                      ref="grid"
                      :endpoint="api.$.evedpaycard.statements"
                      :sort="sortStatements"
                      :views="false"
                      footer
                      legacy
                      alias="EvedPayCardsAccountStatements"
                      :filter="filterStatements"
                      :key="gridTabKey"
                      :checkboxes="false"
                      fit-columns>
                </Grid>
              </div>
            </div>
        </ed-section>
      </div>
    </div>
    <CreateEnvelope title="CREATE ENVELOPE"
                    :initial-rows="!showTransactionsTab ? [] : selectedRows"
                    :editEnvelope="!showTransactionsTab"
                    :envelope="envelope"
                    @fields-updated="handleFieldsUpdated"
                    v-if="showCreateEnvelope"
                    @success="showCreateEnvelope=!showCreateEnvelope; selectedRows = []; envelope = {}; showEnvelopes()"
                    @backToTransactions="showCreateEnvelope=!showCreateEnvelope; updateUrlBackToAccountPage(); selectedRows = []; envelope = {}">
    </CreateEnvelope>
    <CandidateSelector
      :show="showCandidateSelector"
      :receipt-scan-id="candidateSelectorReceiptId"
      :candidates="candidateSelectorCandidates"
      :row-version="candidateSelectorRowVersion"
      :auto-linked="candidateSelectorAutoLinked"
      :auto-fill="candidateSelectorAutoFill"
      :is-mobile="false"
      :claim-mode="false"
      :loading="candidateSelectorLoading"
      :local-image-url="candidateSelectorLocalImageUrl"
      :local-image-content-type="candidateSelectorLocalImageType"
      @match-attempt="handleMatchAttempt"
      @match-selected="handleMatchSelected"
      @match-error="handleMatchError"
      @save-to-folder="handleSaveToFolder"
      @close="handleCandidateSelectorClose"
    />
    <ed-modal title="Submit Receipt"
              :show="showSubmitReceiptModal"
              @close="closeSubmitReceiptModal"
              @validate="confirmSubmitReceipt"
              primary-button="Submit"
              :primaryButtonDisabled="!pendingReceiptFile || uploadingReceipt"
              type="medium"
              validation>
      <div slot="body">
        <p style="margin-bottom: 18px; white-space: nowrap;">Upload an image of a receipt and it will be matched to a transaction and coded automatically.</p>
        <template v-if="uploadingReceipt">
          <label><strong>Uploading</strong></label>
          <div style="display: flex; align-items: center; gap: 8px; padding: 12px 0 24px;">
            <div style="flex: 1; height: 8px; background: #F5F5F5; border-radius: 100px; overflow: hidden;">
              <div :style="{ width: uploadProgressPct + '%', height: '100%', background: '#1890FF', borderRadius: '100px' }"></div>
            </div>
            <span style="font-family: Roboto, sans-serif; font-size: 14px; line-height: 22px; color: rgba(0, 0, 0, 0.85); width: 32px; text-align: right;">{{ uploadProgressPct }}%</span>
          </div>
        </template>
        <template v-else>
          <label><strong>Receipt</strong></label>
          <div v-if="!pendingReceiptFile">
            <ed-button button-class="btn btn-actionbar" @click="triggerReceiptFileInput">
              UPLOAD NEW RECEIPT
            </ed-button>
          </div>
          <div v-else style="display: flex; align-items: center; gap: 10px; padding: 12px 8px; border-bottom: 1px solid rgba(0,0,0,0.08); margin-bottom: 28px;">
            <i class="fas" :class="pendingReceiptIcon.iconClass" :style="{ color: pendingReceiptIcon.color, fontSize: '18px' }"></i>
            <a :href="pendingReceiptObjectUrl || undefined" target="_blank" rel="noopener" style="color: #4a90e2; text-decoration: underline; flex: 1; font-size: 12px;">{{ pendingReceiptFile.name }}</a>
            <span style="color: #999; font-size: 12px;">{{ formatFileSize(pendingReceiptFile.size) }}</span>
            <a href="javascript:;" @click="clearPendingReceiptFile" v-tooltip="'Remove'" style="line-height: 0;">
              <i class="fas fa-times-circle" style="color: #888; font-size: 18px;"></i>
            </a>
          </div>
        </template>
      </div>
    </ed-modal>
    <ed-modal :type="fields && fields.length > 0 && fields[0] && fields[0].length > 0 ? 'extra-large' : 'medium-large'"
              title="Reconcile Transaction"
              :show="showReconcile"
              @close="showModal(showReconcile); closeReconcile()"
              @validate="saveAndReconcile"
              :primary-button="(isUserAdmin || reconcileAction !== 'view') ? 'Save' : 'false'"
              :primaryButtonDisabled="!uploadFinished"
              secondary-button="Cancel"
              validation>
      <Reconcile slot="body"
                 v-if="transaction && transaction.data"
                 :key="transaction.data.Id"
                 :transaction="transaction"
                 :selected-rows="selectedRows"
                 :fields-incomplete="{ receiptIncomplete, descriptionIncomplete }"
                 :reconcile-action="reconcileAction"
                 :receipt-edit-allowed="receiptEditAllowed"
                 @reconcile-created="handleReconcileCreated"
                 @fields-updated="handleFieldsUpdated"
                 @mediaFilesPathUpdated="updateMediaFilesPath"
                 @attachmentsUpdated="updateAttachmentsFiles"
                 @additional-documents-updated="updateAdditionalDocuments"
                 @split-amounts="handleSplitAmounts"
                 @description-text="handleDescriptionText"
                 @uploadFinished="handleUploadFinished"
                 ref="reconcileComp">
      </Reconcile>
    </ed-modal>
    <ed-modal title="EvedPay Account Refill Settings"
              :show="accountRefillSettings.Visible"
              @close="accountRefillSettings.Visible = false, accountRefillSettings.ActionDisabled = true"
              primary-button="Save"
              :primaryButtonDisabled="accountRefillSettings.ActionDisabled"
              @validate="$refs.accountRefillSettingsComponent.save()"
              validation>
      <AccountRefillSettings ref="accountRefillSettingsComponent" :accountId="$route.query.AccountId" slot="body"
                             @success="accountRefillSettings.Visible = false"
                             @loaded="accountRefillSettings.ActionDisabled = false" />
    </ed-modal>
    <ed-modal type="medium" title="Approvers List" :show="showApprovalUsers" @close="showApprovalUsers = false" primary-button="Close" secondary-button="false">
      <ApprovalNeededUsers slot="body" :approvalUsersData="approvalUsersData" />
    </ed-modal>
    <ApproveDialog :showModal="showApproveDialog"
                   :list="transformRows(selectedRows)"
                   :programLabel="programLabel"
                   :cardApproval="cardApproval"
                   :envelopeApproval="envelopeApproval"
                   @approve="doApprove"
                   @close="() => { showApproveDialog = false }" />
    <ed-modal title="Card Decline Reason" :show="showCardRejectInfo" @close="showCardRejectInfo = false" primary-button="Close" secondary-button="false">
      <CardRejectInfo slot="body" :card="card" />
    </ed-modal>
    <ed-modal title="Card Number" :show="showShowCardNumber" @close="closeShowCardNumber" primary-button="false" secondary-button="false" type="compact">
      <ShowCardNumber slot="body" ref="showCardNumberComponent" :card="cardForShowNumber" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${processedSelectedObj.Id}/${this.cardStatus}`" :title="modalTitle" :show="showCardStatus.showModal" @close="closeCardStatusModal" @validate="$refs.cardStatusComponent.changeStatus(cardStatus, showCardStatus)" primary-button="Submit" type="medium" validation :primary-button-disabled="isCardStatusSubmitDisabled">
      <CardStatus ref="cardStatusComponent" slot="body" :status="cardStatus" :cards="selectedObj" :is-eved-admin="isEvedAdmin" @helpDeskTicketNumber="(v) => helpDeskTicketNumber = v" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${processedSelectedObj.Id}/add-funds`" title="Add Funds" :show="showAddFunds" @close="showAddFunds = false" validation @validate="addFunds"
              primary-button="Add" @confirm="addfunds()">
      <CardAddFunds slot="body" :addFundsError="this.addFundsErrors" :balance="account.Available" @fundingAmount="(value) => fundingAmount = value" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${processedSelectedObj.Id}/additional-users`" title="Additional Users" :show="showCardAdditionalUsers" @close="showCardAdditionalUsers = false" @confirm="updateAdditionalUsers" primary-button="Save">
      <CardAdditionalUsers slot="body" :divisionId="processedSelectedObj.DivisionId" :cardId="processedSelectedObj.Id" :cardHolderId="processedSelectedObj.HolderUserId" @additionalUsers="(o) => additionalUsers = o" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${processedSelectedObj.Id}/remove-funds`" title="Return Funds to Account" :show="showReturnFundsToAccount" @close="showReturnFundsToAccount = false" primary-button="Submit" validation @validate="doReturnFunds" @confirm="doReturnFunds()">
      <ReturnFunds :card="processedSelectedObj" slot="body" @returnFunds="(value) => returnFunds = value" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${processedSelectedObj.Id}/refill-settings`" title="Refill Settings" :show="isRefillOpen.showModal" @close="isRefillOpen.showModal = false" primary-button="Save" @validate="$refs.cardRefillComponent.doRefill(isRefillOpen)" validation>
      <RefillSettings ref="cardRefillComponent" :card="processedSelectedObj" slot="body" @refillSuccess="showRefillToast" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${processedSelectedObj.Id}/daily-spend-limit`" title="Daily Spend Limit" :show="isDailySpendLimitOpen.showModal" @close="isDailySpendLimitOpen.showModal = false" primary-button="Save" @validate="$refs.cardDailySpendLimitComponent.save(isDailySpendLimitOpen)" validation>
      <CardDailySpendLimit ref="cardDailySpendLimitComponent" :card="processedSelectedObj" slot="body" />
    </ed-modal>
    <ed-modal :modalEndpoint="`evedpaycards/${processedSelectedObj.Id}/accounting-system-settings`"
      :title="'PSL+ Settings'" primary-button="Save" :show="showAccountingSystemSettings" 
      @validate="handlePslSettingsSave"  @close="showAccountingSystemSettings = false" validation>
      <AccountingSystemSettings ref="accountingSystemSettingsCmp" :card="processedSelectedObj" :accountSettings="accountSettings" slot="body" />
    </ed-modal>
    <ed-modal :modalEndpoint="api.$.evedpaycard.list"
              title="Request Physical Card Batch"
              :show="showRequestPhysicalBatchOpen.showModal"
              @close="showRequestPhysicalBatchOpen.showModal = false"
              primary-button="Request"
              @validate="$refs.physicalCardComponent.requestPhysicalCard(showRequestPhysicalBatchOpen)"
              validation>

      <RequestPhysicalBatch ref="physicalCardComponent"
                            :filteredCards="showRequestPhysicalBatchOpen.dataFlag === 'filtered' ? showRequestPhysicalBatchOpen.data : []"
                            :list="showRequestPhysicalBatchOpen.dataFlag === 'selected' ? showRequestPhysicalBatchOpen.data : []"
                            :divisionId="account.DivisionId"
                            :account="account"
                            @success="handleRequestPhysicalSuccess"
                            slot="body" />
    </ed-modal>
  </div>
</template>

<script>

import Grid from '@/components/Grid'
import { EventBus } from '@/event-bus'
import events from '@/core/events/events'
import modelTransactions from '../Card-transactions/model.js'
import modelEnvelopes from '../Card-envelopes/model'
import modelCardHistory from '@/components/_modules/Programs/Card-history/model.js'
import modelCards from '@/components/_modules/Programs/Card-cards/model.js'
import modelAccountStatements from '@/components/_modules/Programs/Card-account-statements/model.js'
import AddCard from './AddCard.vue'
import AccountRefillSettings from './AccountRefillSettings.vue'
import AddFunding from './AddFunding.vue'
import RejectCard from './RejectCard.vue'
import ApprovalNeededUsers from './ApprovalNeededUsers.vue'
import ApproveDialog from '@/components/_modules/Dashboard/widgets/ApprovalNeeded/approve-dialog'
import RejectEnvelope from '@/components/_modules/Programs/Card-envelopes/RejectEnvelope.vue'
import RejectCardFunding from './RejectCardFunding.vue'
import RejectCardRefill from './RejectCardRefill.vue'
import RejectCardDailySpendLimit from './RejectCardDailySpendLimit.vue'
import CardSettings from './CardSettings.vue'
import CloseAccount from './CloseAccount.vue'
import CreateEnvelope from '@/components/_modules/Programs/Card-transactions/CreateEnvelope.vue'
import Reconcile from '@/components/_modules/Programs/Card-transactions/ReconcileTransaction.vue'
import CandidateSelector from '@/components/_modules/Programs/Card-transactions/CandidateSelector'
import receiptScansApi from '@/core/api/receiptScans'
import createReceiptScanPoller from '@/core/receiptScan/receiptScanPoller'
import compressReceiptImage from '@/core/receiptScan/imageCompression'
import featureFlags from '@/core/feature-flags/feature-flags'
import CardRejectInfo from './CardRejectInfo.vue'
import CardStatus from './CardStatus.vue'
import RequestPhysicalCard from './RequestPhysicalCard.vue'
import AddTransactionNumber from '@/components/_modules/Programs/Card-envelopes/AddTransactionNumber'
import CardAddFunds from './CardAddFunds.vue'
import ReturnFunds from './ReturnFundsToAccount.vue'
import RefillSettings from './CardRefill.vue'
import CardDailySpendLimit from './CardDailySpendLimit.vue'
import AccountingSystemSettings from '@/components/_modules/Programs/Card-list/AccountingSystemSettings.vue'
import CardAdditionalUsers from './CardAdditionalUsers.vue'
import ShowCardNumber from './ShowCardNumber.vue'
import RequestPhysicalBatch from './RequestPhysicalBatch.vue'
import CardCards from '@/components/_modules/Programs/Card-cards'

const { methods: cardMethods } = CardCards

// reload page after browser back pressed
function handlePopState(event) {
  if (document.location.href.includes('list')) {
    window.location.reload()
  }
}
window.addEventListener('popstate', handlePopState)

export default {
  components: {
    Grid,
    CreateEnvelope,
    Reconcile,
    CandidateSelector,
    AddCard,
    AccountRefillSettings,
    AddFunding,
    RejectCard,
    RejectCardFunding,
    RejectCardRefill,
    RejectCardDailySpendLimit,
    ApprovalNeededUsers,
    ApproveDialog,
    RejectEnvelope,
    CardSettings,
    CloseAccount,
    CardRejectInfo,
    CardStatus,
    RequestPhysicalCard,
    AddTransactionNumber,
    CardAddFunds,
    ReturnFunds,
    RefillSettings,
    CardDailySpendLimit,
    AccountingSystemSettings,
    RequestPhysicalBatch,
    CardAdditionalUsers,
    ShowCardNumber
  },

  data() {
    return {
      divName: '',
      showTransactionsTab: true,
      showEnvelopesTab: false,
      showCardHistoryTab: false,
      showCardsTab: false,
      showAccountStatementsTab: false,
      divisions: [],
      selectedAccountId: null,
      selectedProgram: 0,
      selectedSupplier: 0,
      fields: [],
      formKey: '',
      splitAmounts: [],
      noteText: '',
      mediaFilesPath: '',
      filteredAttachments: [],
      // PRODUCTDEV-5772 — supporting documents, kept separate from receipts.
      additionalDocumentsFiles: [],
      receiptIncomplete: false,
      requireReceiptDescription: Boolean,
      descriptionIncomplete: false,
      savePressed: false,
      selectedDivisionName: '...',
      modelTransactions,
      modelTransactionsAccount: { ...modelTransactions },
      modelEnvelopes,
      modelCardHistory,
      modelCards,
      modelCardsAccount: { ...modelCards },
      modelAccountStatements,
      sort: { TransactionDateFormatted: 'desc' },
      sortHistory: { Date: 'desc' },
      sortEnvelopes: { CreatedDate: 'desc' },
      sortCards: { CardNumber: 'desc' },
      sortStatements: { CreatedDate: 'desc' },
      hasData: false,
      headerData: {
        Funded: '',
        Allocated: '',
        Available: '',
        Pending: ''
      },
      cardsList: [{}],
      account: {},
      accountSettings: { AccountingSystem: {} },
      division: {},
      accountRefillSettings: { Visible: false, ActionDisabled: true },
      closeObj: {},
      selectedRows: [],
      selectedAll: null,
      programName: '',
      showCreateEnvelope: false,
      showReconcile: false,
      receiptScanEnabled: featureFlags.receiptScanPrefill,
      // PRODUCTDEV-5788 — account-scoped table: a single division is in context, so gate the
      // Submit Receipt button on THAT division's receipt-scan mode. Default false; set true in
      // getAccountData() once the mode resolves and is not "No Receipt Capture".
      accountScanEnabled: false,
      uploadingReceipt: false,
      uploadProgressPct: 0,
      showSubmitReceiptModal: false,
      pendingReceiptFile: null,
      // PRODUCTDEV-5804 — object URL for the pending file so the chip link carries a real href
      // (right-click "Open in new tab"). Lifecycle owned by the pendingReceiptFile watcher.
      pendingReceiptObjectUrl: '',
      showCandidateSelector: false,
      candidateSelectorReceiptId: null,
      candidateSelectorCandidates: [],
      candidateSelectorRowVersion: null,
      candidateSelectorAutoLinked: false,
      candidateSelectorAutoFill: null,
      candidateSelectorLoading: false,
      // True while a SUBMIT-click match POST is in flight. Used to suppress the
      // dispose-on-cancel path in handleCandidateSelectorClose since ed-modal
      // auto-emits @close immediately after @confirm (edModal/index.vue:161-163).
      candidateSelectorMatching: false,
      candidateSelectorLocalImageUrl: null,
      candidateSelectorLocalImageType: null,
      // Legacy /UploadReceiptReconcile response captured at SUBMIT time so
      // we can hand the canonical TransactionFiles metadata (PathWithName,
      // MediaFile, FullPath) to ReconcileTransaction once the user picks a
      // match. Without this the saved reconcile has no TransactionFiles row,
      // and reopen-view crashes on Substring(0,-1) of an empty path.
      pendingLegacyReceipt: null,
      activePoller: null,
      pollInterval: null,
      isActive: false,
      showApprovalUsers: false,
      approvalUsersData: [],
      showApproveDialog: false,
      reconcileAction: 'create',
      editAuth: null,
      selectedBu: [],
      selectedCc: [],
      selectedBuAndCcPair: [],
      selectedCategory: [],
      referenceId: [],
      descriptions: [],
      splitCounter: 1,
      buAndCcPairIncomplete: [],
      buIncomplete: [],
      ccIncomplete: [],
      categoryIncomplete: [],
      itemIds: [],
      refreshScheduled: false,
      envelope: {},
      transaction: {},
      highlightedObjectId: '',
      rowClasses: {
        'row-highlight': params => {
          return (params.data && (params.data.Id === this.highlightedObjectId || params.data.EnvelopeId === this.highlightedObjectId))
        }
      },
      showCardRejectInfo: false,
      card: [],
      noTooltipFields: ['TransactionStatus', 'ReconciliationStatus', 'TransactionNumber', 'EnvelopeNumber', 'EnvelopeStatus'],
      showShowCardNumber: false,
      showCardStatus: { showModal: false },
      helpDeskTicketNumber: '',
      showAddCard: false,
      showRequestPhysicalCardOpen: { showModal: false },
      showRequestPhysicalBatchOpen: {
        showModal: false,
        dataFlag: '',
        data: null
      },
      mailingAddress: {},
      cardStatus: '',
      divisionName: '',
      divisionsName: '',
      cardDivisionId: null,
      modalTitle: '',
      selectedObj: [],
      waitingApprovalStatuses: ['Open - Waiting Approval', 'Exported - Waiting Approval', 'Posted - Waiting Approval'],
      rejectedStatuses: ['Rejected', 'Declined', 'Exported - Rejected', 'Posted - Rejected', 'Exported - Declined', 'Posted - Declined'],
      addFundsErrors: false,
      showAddFunds: false,
      fundingAmount: 0,
      showReturnFundsToAccount: false,
      returnFunds: '',
      isRefillOpen: { showModal: false },
      isDailySpendLimitOpen: { showModal: false },
      showAccountingSystemSettings: false,
      showCardAdditionalUsers: false,
      additionalUsers: [],
      disabledResendButtons: {},
      pushingToAccountingSystem: false,
      hasPhysicalCards: false,
      uploadFinished: true
    }
  },

  async created() {
    this.selectedAccountId = this.$route.query.AccountId
    this.divisionName = this.singularize(this.$root.getUser.settings.Labels.DivisionName)
    this.divisionsName = this.$root.getUser.settings.Labels.DivisionsName
    this.programName = this.singularize(this.$root.getUser.settings.Labels.ProgramLabel)
    this.modelTransactionsAccount.ProgramName.label = this.programName
    this.modelTransactionsAccount.Division = '_'
    this.modelEnvelopes.ProgramName.label = this.programName
    if (!this.$root.getUser.settings.HasBusinessUnit) {
      delete this.modelEnvelopes.BusinessUnit
    }
    this.modelCardsAccount.Division = '_'

    EventBus.$off('status-changed')
    EventBus.$on('status-changed', (cardId) => {
      this.refreshCardWithDetails(cardId.data)
    })
    EventBus.$off('refill')
    EventBus.$on('refill', (cardId) => {
      this.refreshCardWithDetails(cardId.data)
    })

    EventBus.$off('dailySpendLimit')
    EventBus.$on('dailySpendLimit', (cardId) => {
      this.refreshCardWithDetails(cardId.data)
    })

    EventBus.$off('funds-changed')
    EventBus.$on('funds-changed', (cardId) => {
      this.refreshCardWithDetails(cardId.data)
      this.getAccountData()
    })

    EventBus.$off(events.EVEDPAY_CARDS.OPEN_ENVELOPE)
    EventBus.$on(events.EVEDPAY_CARDS.OPEN_ENVELOPE, envelope => {
      this.envelope = envelope.data
      this.showCreateEnvelope = true
    })
    EventBus.$off('receipt-scan-started')
    EventBus.$on('receipt-scan-started', (payload) => {
      this.handleReceiptScanStarted(payload.data)
    })

    EventBus.$off(events.EVEDPAY_CARDS.OPEN_RECONCILE)
    EventBus.$on(events.EVEDPAY_CARDS.OPEN_RECONCILE, this.handleTransaction)

    EventBus.$off('transaction-reconciled')
    EventBus.$on('transaction-reconciled', (transactionId) => {
      if (this.transaction && this.transaction.data) {
        const matchedTransaction = this.transaction.data.Id === transactionId.data

        if (matchedTransaction) {
          const transactionNumber = this.transaction.data.TransactionNumber
          this.$notifications.notify({
            message: `Transaction ${transactionNumber} was updated!`,
            type: 'info',
            placement: { from: 'top', align: 'center' }
          })
        }
      }
    })

    this.highlightedObjectId = localStorage.getItem('row-highlight')

    EventBus.$off('physicalCardRequested')
    this.initializeData()
  },

  activated() {
    this.showCreateEnvelope = false
    this.envelope = {}
    this.showTransactions()
    if (this.$route.query.StatementsTab) {
      this.showAccountStatements()
      const newQuery = { ...this.$route.query }
      delete newQuery.StatementsTab
      this.$router.replace({ query: newQuery })
    }
  },

  computed: {
    // PRODUCTDEV-5804 — icon glyph + color for the pending receipt chip (ed-upload palette).
    pendingReceiptIcon() {
      var name = ((this.pendingReceiptFile && this.pendingReceiptFile.name) || '').toLowerCase()
      if (/\.pdf$/.test(name)) return { iconClass: 'fa-file-pdf', color: '#cb0404' }
      if (/\.(png|jpe?g|gif|webp)$/.test(name)) return { iconClass: 'fa-file-image', color: '#4598d9' }
      return { iconClass: 'fa-file', color: '#acacac' }
    },
    selectedId() {
      return this.transaction && this.transaction.data &&
        this.transaction.data.PaymentInvoiceID
    },

    isUserAdmin() {
      // OR EvedPayCardViewReconcileClose so the reconcile/view admin-equivalent gets
      // the same affordances as EvedPayCardAdministrator — matches the legacy EPC pattern
      // already used by hasAccountPermission gates throughout this template.
      var perms = this.$user.$.userPermissions
      if (perms.includes('EvedPayCardAdministrator') || perms.includes('EvedPayCardViewReconcileClose')) {
        return true
      }
      return false
    },

    // PRODUCTDEV-5574 — preserves the pre-existing receipt-upload rules for this view too. See
    // Card-transactions/index.vue for the rationale.
    receiptEditAllowed() {
      if (this.isUserAdmin) return true
      const t = this.transaction && this.transaction.data
      if (!t || !t.TransactionStatus) return false
      const inEnvelopeReadonly = ['In Envelope', 'Exported', 'Posted'].includes(t.TransactionStatus)
      if (!inEnvelopeReadonly) return t.ReconciliationStatus !== 'Approved'
      if (t.EnvelopeStatus === 'Draft') return true
      if (t.ReconciliationStatus === 'Approved') return false
      return this.isUserInApprovalList()
    },

    isEvedAdmin() {
      return !!(this.$user && this.$user.$ && this.$user.$.user && this.$user.$.user.IsEvedAdmin)
    },

    isCardStatusSubmitDisabled() {
      const isLockUnlock = this.cardStatus === 'lock' || this.cardStatus === 'unlock'
      return isLockUnlock && this.isEvedAdmin && !this.helpDeskTicketNumber.trim()
    },

    filter() {
      if (this.hasAccountPermission('EvedPayCardAdministrator') || this.hasAccountPermission('EvedPayCardViewReconcileClose')) {
        return {
          AccountId: { filter: this.$route.query.AccountId }
        }
      } else {
        return {
          HolderUserId: { filter: this.$user.$.user.UserID },
          AccountId: { filter: this.$route.query.AccountId }
        }
      }
    },

    showApproveButton() {
      return this.isUserInApprovalList()
    },

    showRejectButton() {
      return this.isUserInApprovalList()
    },

    filterHistory() {
      return {
        AccountID: { filter: this.$route.query.AccountId }
      }
    },

    filterCards() {
      return {
        AccountId: { filter: this.$route.query.AccountId }
      }
    },

    filterStatements() {
      return {
        AccountId: { filter: this.$route.query.AccountId }
      }
    },

    gridTabKey() {
      return `${this.showTransactionsTab} ${this.showEnvelopesTab} ${this.showCardHistoryTab} ${this.showCardsTab} ${this.showAccountStatementsTab} ${this.$route.query.AccountId}`
    },

    processedSelectedObj() {
      return this.selectedObj[0] || {}
    },

    cardForShowNumber() {
      var obj = this.processedSelectedObj
      var fullCard = obj.Id ? this.cardsList.find(function (c) { return c.Id === obj.Id }) : null
      return {
        Id: obj.Id,
        AccountId: obj.AccountId,
        CardNumber: obj.CardNumber,
        Holder: obj.Holder || '',
        NameOnCard: obj.NameOnCard || (fullCard && fullCard.NameOnCard) || '',
        ExpirationDate: (fullCard && fullCard.ExpirationDate) || obj.ExpirationDate || ''
      }
    },

    lockUnlockButtonText() {
      if (this.selectedObj.length > 0) {
        const cardStatus = this.selectedObj[0].CardStatus
        switch (cardStatus) {
          case 'Active':
            return 'Lock Card'
          case 'Locked':
            return 'Unlock Card'
          case 'Locked - Lost/Stolen':
            return 'Unlock Card'
          case 'Closed':
            return 'Lock Card'
          default:
            return 'Lock Card'
        }
      }
      return 'Lock Card'
    }
  },

  mounted() {
    this.isActive = true
    this.$nextTick(() => {
      const summaryCardFooter = document.querySelectorAll('.dawn-card-footer')
      summaryCardFooter.forEach(el => {
        el.style.pointerEvents = 'none'
        el.style.zIndex = '-1'
        el.style.opacity = '0'
      })
    })
  },

  watch: {
    // PRODUCTDEV-5804 — own the pending file's object URL lifecycle (revoke old, create new) so the
    // chip link has a stable href. Covers every assignment site to pendingReceiptFile.
    pendingReceiptFile(file) {
      if (this.pendingReceiptObjectUrl) { URL.revokeObjectURL(this.pendingReceiptObjectUrl); this.pendingReceiptObjectUrl = '' }
      if (file) this.pendingReceiptObjectUrl = URL.createObjectURL(file)
    },
    showCreateEnvelope(newValue) {
      if (newValue) {
        this.highlightedObjectId = this.envelope.Id
      }
    },

    selectedAccountId(newValue) {
      this.rememberLastAccount(newValue)
    },

    'showRequestPhysicalBatchOpen.showModal': async function (newVal) {
      if (newVal) {
        await this.getCards(this.$route.query.AccountId)

        this.showRequestPhysicalBatchOpen.data =
          this.showRequestPhysicalBatchOpen.dataFlag === 'filtered'
            ? this.filteredPhysicalCards
            : this.selectedRows
      }
    },

    // Revoke the receipt's local objectURL when the Select Transaction modal closes,
    // regardless of which path closed it (X button, auto-link redirect, no-candidates,
    // error). Keeps memory tidy — objectURLs leak until the document is destroyed.
    showCandidateSelector(newVal) {
      if (!newVal && this.candidateSelectorLocalImageUrl) {
        URL.revokeObjectURL(this.candidateSelectorLocalImageUrl)
        this.candidateSelectorLocalImageUrl = null
        this.candidateSelectorLocalImageType = null
      }
    }
  },

  methods: {
    ...cardMethods,
    formatCardHolderLine(card) {
      const holderName = (card && card.Holder && card.Holder.Name) || ''
      const nameOnCard = ((card && card.NameOnCard) || '').trim()
      if (nameOnCard && nameOnCard !== holderName.trim()) {
        return `${nameOnCard} | ${holderName}`
      }
      return holderName
    },
    async initializeData() {
      await this.getDivision()
      await this.getUserDivisions()
      await this.getCardsAndAccountData()
    },

    async addFunds() {
      return cardMethods.addFunds.call(this)
    },

    async doReturnFunds() {
      return cardMethods.doReturnFunds.call(this)
    },

    async handlePslSettingsSave() {
      const res = await this.$refs.accountingSystemSettingsCmp.save()
      this.showAccountingSystemSettings = !res
      return res
    },

    async updateAdditionalUsers() {
      return cardMethods.updateAdditionalUsers.call(this)
    },

    lostStolen() {
      return cardMethods.lostStolen.call(this)
    },

    getCardsAndAccountData() {
      this.getAccountData()
      this.getCards(this.selectedAccountId)
    },

    isPoolFunding(card) {
      // PRODUCTDEV-5881: a card follows pool funding rules when its account is Pool - Shared Funds
      // (card.IsPoolFunding) OR it carries the legacy per-card UseAutoCardFunding flag.
      return !!(card && (card.IsPoolFunding || card.UseAutoCardFunding))
    },

    // PRODUCTDEV-5908: count the active pending-approval sections on a card (Funding, Refill Settings,
    // Daily Spend Limit). The card-info column plus these sections all share one row, so both the card's
    // grid-cell width (cardClass) and each inner column width (cardApprovalColClass) key off this count.
    activeApprovalSections(card) {
      return (card.PendingRequest > 0 ? 1 : 0) +
        ((card.RefillSettings || {}).HasRefillRequest ? 1 : 0) +
        (card.HasDailySpendLimitRequest ? 1 : 0)
    },

    // PRODUCTDEV-5908: widen the card's cell in the .card-container grid (24% columns) so the info column
    // and every pending-approval section sit on one row, exactly like Funding / Refill. The card spans
    // (sections + 1) columns; with no pending approval it keeps the default single-column width.
    // Previously only Funding / Refill widened the card, so a Daily Spend Limit card stayed one column wide
    // and its to-the-right section was crammed into ~24%, wrapping the text (see PRODUCTDEV-5908 screenshot).
    cardClass(card) {
      const sections = this.activeApprovalSections(card)
      return sections > 0 ? 'cardApprovalSpan-' + (sections + 1) : ''
    },

    // PRODUCTDEV-5908: size the card-info column and each pending-approval section (Funding, Refill Settings,
    // Daily Spend Limit) so they always share a single Bootstrap row. The info column plus N active approval
    // sections split the 12-column grid evenly: 0 -> col-md-12, 1 -> col-md-6, 2 -> col-md-4, 3 -> col-md-3.
    // This replaces the per-section col-md-4/col-md-6 ternaries, which only accounted for Funding + Refill and
    // left a Daily Spend Limit section (or any third section) overflowing onto the next row instead of sitting
    // to the right. All counts yield a whole Bootstrap width, so no fractional col-md-* class is produced.
    cardApprovalColClass(card) {
      return 'col-md-' + (12 / (this.activeApprovalSections(card) + 1))
    },

    async getCardWithDetails(cardId) {
      try {
        // PRODUCTDEV-5884: QA hit a 500 ("Something went wrong") on the post-save refresh after a Daily
        // Spend Limit change - DevTools showed card-with-details called with a malformed wrapped id
        // (id={data:<guid>}) while the DSL PATCH itself returned 200 (the change saved). Callers reach
        // this through several EventBus/@success paths with inconsistent payload shapes (most pass the
        // bare id; some wrap it as { data: <id> }), so defensively normalize any wrapped value to the
        // bare id and bail if none resolves. NOTE: if a 500 recurs here with a *bare* id, the cause is
        // server-side in card-with-details (e.g. a pool card with a pending DSL approval), not this URL.
        let id = cardId
        while (id && typeof id === 'object') {
          id = id.data
        }
        if (!id) {
          console.warn('getCardWithDetails: no card id resolved from', cardId)
          return
        }
        const params = {
          id
        }
        const response = await this.api.get(this.api.$.evedpaycard.cardWithDetails, { params })
        if (response.data) {
          const matchedCard = this.cardsList.findIndex(card => card.Id === id)

          if (matchedCard !== -1) {
            this.$set(this.cardsList, matchedCard, response.data)
            this.sortCardsList()
          }
        }
      } catch (error) {
        console.log(error)
      }
    },

    async approveOrReject(cardId) {
      try {
        let payload = {
          cardsData: JSON.stringify([{ Id: cardId }])
        }
        const response = await this.api.post(this.api.$.evedpaycard.approveOrReject, payload)
        if (response.data === 'Success') {
          setTimeout(() => {
            this.refreshCardWithDetails(cardId)
          }, 1000)
        } else {
          throw new Error('Error during the request')
        }
      } catch (error) {
        console.error(error)
      }
    },

    async approveOrRejectEvedPayCardFunding(cardId) {
      try {
        let payload = {
          cardsData: JSON.stringify([{ Id: cardId }])
        }
        const response = await this.api.post(this.api.$.evedpaycard.approveOrRejectCardFunding, payload)
        if (!response.data) {
          throw new Error('Error during the request')
        }
        this.refreshCardWithDetails(cardId)
      } catch (error) {
        console.error(error)
      }
    },

    async approveOrRejectEvedPayCardRefill(cardId) {
      try {
        let payload = {
          cardsData: JSON.stringify([{ Id: cardId }])
        }
        const response = await this.api.post(this.api.$.evedpaycard.approveOrRejectCardRefill, payload)
        if (!response.data) {
          throw new Error('Error during the request')
        }
        this.refreshCardWithDetails(cardId)
      } catch (error) {
        console.error(error)
      }
    },

    async resendCardApprovalEmail(cardId) {
      this.$set(this.disabledResendButtons, cardId, true)
      try {
        await this.api.post(this.api.$.evedpaycard.resendCardApprovalEmail, {
          cardId: cardId
        })
      } catch (error) {
        console.error('There was a problem with the approval email resend request:', error)
        this.$set(this.disabledResendButtons, cardId, false)
      }
    },

    async resendCardFundingApprovalEmail(cardId) {
      const key = `${cardId}-funding`
      this.$set(this.disabledResendButtons, key, true)
      try {
        await this.api.post(this.api.$.evedpaycard.resendCardFundingApprovalEmail, {
          cardId: cardId
        })
      } catch (error) {
        console.error('There was a problem with the approval email resend request:', error)
        this.$set(this.disabledResendButtons, key, false)
      }
    },

    async resendCardRefillApprovalEmail(cardId) {
      const key = `${cardId}-refill`
      this.$set(this.disabledResendButtons, key, true)
      try {
        await this.api.post(this.api.$.evedpaycard.resendCardRefillApprovalEmail, {
          cardId: cardId
        })
      } catch (error) {
        console.error('There was a problem with the approval email resend request:', error)
        this.$set(this.disabledResendButtons, key, false)
      }
    },

    // PRODUCTDEV-5884 (pool funding): approve a pending Daily Spend Limit change from the tile (mirror of
    // approveOrRejectEvedPayCardRefill). Decline goes through the RejectCardDailySpendLimit component.
    async approveOrRejectEvedPayCardDailySpendLimit(cardId) {
      try {
        let payload = {
          cardsData: JSON.stringify([{ Id: cardId }])
        }
        const response = await this.api.post(this.api.$.evedpaycard.approveOrRejectCardDailySpendLimit, payload)
        if (!response.data) {
          throw new Error('Error during the request')
        }
        this.refreshCardWithDetails(cardId)
      } catch (error) {
        console.error(error)
      }
    },

    async resendCardDailySpendLimitApprovalEmail(cardId) {
      const key = `${cardId}-dsl`
      this.$set(this.disabledResendButtons, key, true)
      try {
        await this.api.post(this.api.$.evedpaycard.resendCardDailySpendLimitApprovalEmail, {
          cardId: cardId
        })
      } catch (error) {
        console.error('There was a problem with the approval email resend request:', error)
        this.$set(this.disabledResendButtons, key, false)
      }
    },

    getApprovalUsers(cardId) {
      this.api.get(this.api.$.evedpaycard.approvalUsers, {
        params: {
          cardId
        }
      })
        .then(response => {
          this.approvalUsersData = response.data
        })
        .catch(error => {
          console.error('There was a problem with the approval users request:', error)
        })
    },

    getRefillApprovalUsers(cardId) {
      this.api.get(this.api.$.evedpaycard.refillApprovalUsers, {
        params: {
          cardId
        }
      })
        .then(response => {
          this.approvalUsersData = response.data
        })
        .catch(error => {
          console.error('There was a problem with the approval users request:', error)
        })
    },

    async handleButtonClick(cardId, refill) {
      try {
        if (refill) {
          await this.getRefillApprovalUsers(cardId)
        } else {
          await this.getApprovalUsers(cardId)
        }

        this.showApprovalUsers = true
      } catch (error) {
        console.error('There was a problem handling the button click:', error)
      }
    },

    async handleButtonClickReject(cardId) {
      try {
        this.card = this.cardsList.find(card => card.Id === cardId)

        this.$emit('card', this.card)
        this.showCardRejectInfo = true
      } catch (error) {
        console.error('There was a problem handling the button click:', error)
      }
    },

    async handleSuccess() {
      await this.getCardsAndAccountData()
    },

    sortCardsList() {
      const statusOrder = {
        'Pending Approval': 0,
        'Active': 1,
        'Processing': 2,
        'Inactive': 3,
        'Locked': 4,
        'Locked - Lost/Stolen': 5,
        'Expired': 6,
        'Closed': 7,
        'Rejected': 8,
        'Declined': 8
      }

      this.cardsList.sort((a, b) => {
        const statusA = a.CardStatus || 'N/A'
        const statusB = b.CardStatus || 'N/A'
        return statusOrder[statusA] - statusOrder[statusB]
      })
    },

    async getCards(accountId) {
      try {
        const result = await this.api.get(this.api.$.evedpaycard.list, {
          params: {
            accountId
          }
        })

        this.cardsList = result.data.length ? result.data : [{}]
        this.sortCardsList()

        this.hasData = true
        this.refreshProcessingCards()

        this.filteredPhysicalCards = this.filterPhysicalCards(this.cardsList)
      } catch (error) {
        this.hasData = false
        console.log('error', error)
      }
    },

    filterPhysicalCards(cards) {
      const physicalCards = cards
        .filter(card => !card.IsPhysicalCard && card.CardStatus === 'Active')
        .sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate))
      this.hasPhysicalCards = physicalCards.length > 0
      return physicalCards
    },

    handleRequestPhysicalSuccess() {
      this.getCards(this.$route.query.AccountId)
      this.refresh()
    },

    handleCardAdditionSuccess() {
      this.refreshScheduled = false
      this.refreshCards()
      this.getAccountData()
      this.getCards(this.$route.query.AccountId)
    },

    refreshProcessingCards() {
      this.clearPollInterval()
      const needsRefresh = this.cardsList.some(card =>
        card.CardStatus === 'Processing' || card.CardStatus === 'Pending Approval' || card.CardStatus === 'Rejected' || card.CardStatus === 'Declined'
      )

      if (needsRefresh && !this.refreshScheduled) {
        const delay = 1 * 60 * 1000
        this.pollInterval = setTimeout(() => {
          if (this.isActive) {
            this.refreshCards()
            this.refreshScheduled = true
          }
        }, delay)
      }
    },

    async getUserDivisions() {
      this.users = []
      try {
        const result = await this.api.get(this.api.$.evedpaycard.division)

        if (result && result.data) {
          this.divisions = result.data

          if (!this.$route.query.AccountId && this.divisions.length > 0) {
            const last = this.readLastAccount()
            const target = this.divisions.some(d => d.AccountId === last)
              ? last
              : this.divisions[0].AccountId
            this.redirectCardholder(target)
          }

          const matchedAccount = this.divisions.find(div => div.AccountId === this.selectedAccountId)
          this.divName = matchedAccount ? matchedAccount.DivisionName : '...'

          this.hasData = true
        }
      } catch (error) {
        this.hasData = false
        console.log('error', error)
      }
    },

    getAccountData() {
      return this.api.get(this.api.$.evedpaycard.account + this.$route.query.AccountId)
      .then(result => {
        if (result && result.data) {
          this.account = result.data
          this.getAccountSettings(this.account.DivisionId)
          // PRODUCTDEV-5788 — gate this account's Submit Receipt button on its division's
          // receipt-scan mode. Default false on any failure (button stays hidden).
          if (this.receiptScanEnabled && this.account.DivisionId != null) {
            receiptScansApi.getScanMode(this.account.DivisionId)
              .then((scanSetting) => {
                this.accountScanEnabled = !!(scanSetting && scanSetting.prefillMode !== 'scanning_disabled')
              })
              .catch((modeErr) => {
                console.warn('Could not fetch receipt-scan mode (Submit Receipt hidden):', modeErr)
                this.accountScanEnabled = false
              })
          } else {
            this.accountScanEnabled = false
          }
        } else {
          this.account = {}
          this.accountScanEnabled = false
        }
        this.hasData = true
      })
      .catch(error => {
        this.hasData = false
        console.log('error', error)
      })
    },

    async getAccountSettings(divisionId) {
      if (this.accountSettings && this.accountSettings.DivisionId === divisionId) {
        return
      }

      try {
        const response = await this.api.get(`evedpaycards/accounts/${divisionId}/settings-by-division`)
        if (response.status === 200) {
          this.accountSettings = response.data
        }
      } catch (error) {
        console.log(error)
      }
    },

    async getDivision() {
      try {
        const result = await this.api.get(this.api.$.evedpaycard.division)
        if (result && result.data) {
          for (var divAcc of result.data) {
            if (divAcc.AccountId === this.$route.query.AccountId) {
              this.division = divAcc
            }
          }
        }
        this.hasData = true
      } catch (error) {
        this.hasData = false
        console.log('error', error)
      }
    },

    async approveOrRejectEnvelope(envelopes) {
      try {
        let payload = {
          envelopesData: envelopes
        }
        const response = await this.api.post(this.api.$.evedpaycard.approveOrRejectEnvelope, payload)
        if (!response.data) {
          throw new Error('Error during the request')
        }
        this.refresh()
      } catch (error) {
        console.error(error)
      }
    },

    doApprove() {
      if (this.showEnvelopesTab) {
        const envelopes = this.selectedRows.map(r => r.data)
        this.approveOrRejectEnvelope(envelopes)
      } else if (this.showCardsTab) {
        this.approveOrReject(this.selectedObj[0].Id)
      }
    },

    transformRows(rows) {
      if (this.showEnvelopesTab) {
        return rows.map(r => {
          let amount = parseFloat(r.data.Amount).toFixed(2)
          let row = {
            NeedsApproval: this.waitingApprovalStatuses.includes(r.data.EnvelopeStatus) ? 'EvedPay Envelope' : '',
            Amount: amount + ' USD'
          }
          return row
        })
      } else if (this.showCardsTab) {
        return rows.map(r => {
          let amount = parseFloat(r.data.InitialLoad).toFixed(2)
          let row = {
            NeedsApproval: r.data.CardStatus === 'Pending Approval' ? 'EvedPay Card' : '',
            Amount: amount + ' USD'
          }
          return row
        })
      }
    },

    async getApprovalUsersEnvelope(envelopeId) {
      await this.api.get(this.api.$.evedpaycard.approvalUsersForEnvelope, {
        params: {
          envelopeId
        }
      })
        .then(response => {
          this.approvalUsersData = response.data
        })
        .catch(error => {
          console.error('There was a problem with the approval users request:', error)
        })
    },

    isUserInApprovalList() {
      const currentUserID = this.$root.getUser.$.user.UserID
      if (Array.isArray(this.approvalUsersData)) {
        return this.approvalUsersData.some(user => user.Id === currentUserID && user.IsCurrentAction)
      }
      return false
    },

    async handleButtonClickEnvelope(envelopeId) {
      try {
        await this.getApprovalUsersEnvelope(envelopeId)

        this.showApprovalUsers = true
      } catch (error) {
        console.error('There was a problem handling the button click:', error)
      }
    },

    stopSave() {
      this.savePressed = false
    },

    resetValidation() {
      this.receiptIncomplete = false
      this.descriptionIncomplete = false
      this.buAndCcPairIncomplete = new Array(this.splitCounter).fill(false)
      this.buIncomplete = new Array(this.splitCounter).fill(false)
      this.ccIncomplete = new Array(this.splitCounter).fill(false)
      this.categoryIncomplete = new Array(this.splitCounter).fill(false)
    },

    async createReconcile() {
      let hasIncompleteField = false

      if (!(this.selectedProgram && Object.keys(this.selectedProgram).length !== 0 && this.selectedProgram.Id)) {
        hasIncompleteField = true
      }

      if ((!this.noteText || this.noteText && this.noteText.length === 0) && this.requireReceiptDescription && this.filteredAttachments.length !== 0) {
        this.descriptionIncomplete = true
        hasIncompleteField = true
      } else {
        this.descriptionIncomplete = false
      }

      if (this.filteredAttachments.length === 0) {
        hasIncompleteField = true
      }

      if (this.transaction.data.EnvelopeId &&
        this.transaction.data.EnvelopeId !== '00000000-0000-0000-0000-000000000000' &&
        this.filteredAttachments.length === 0 &&
        this.transaction.data.EnvelopeStatus !== 'Draft'
      ) {
        this.$notifications.notify({
          type: 'info-warn',
          message: 'Receipt is required. Please upload at least one file.',
          placement: { from: 'top', align: 'center' }
        })
        return this.stopSave()
      }

      this.buAndCcPairIncomplete = new Array(this.splitCounter).fill(false)
      this.buIncomplete = new Array(this.splitCounter).fill(false)
      this.ccIncomplete = new Array(this.splitCounter).fill(false)
      this.categoryIncomplete = new Array(this.splitCounter).fill(false)

      for (var i = 0; i < this.splitCounter; i++) {
        if (this.selectedBuAndCcPair) {
          this.buAndCcPairIncomplete[i] = !this.selectedBuAndCcPair[i]
        } else if (this.selectedBu && this.selectedCc) {
          this.buIncomplete[i] = !this.selectedBu[i]
          this.ccIncomplete[i] = !this.selectedCc[i]
        } else if (this.selectedBu && !this.selectedCc) {
          this.buIncomplete[i] = !this.selectedBu[i]
        } else if (!this.selectedBu && this.selectedCc) {
          this.ccIncomplete[i] = !this.selectedCc[i]
        }

        if (this.buAndCcPairIncomplete[i] || this.buIncomplete[i] || this.ccIncomplete[i]) {
          hasIncompleteField = true
        }

        if (!(this.selectedCategory && this.selectedCategory[i])) {
          hasIncompleteField = true
        }

        // check incomplete custom fields
        if (this.fields.some(item =>
          item.some(field => field && field.Required && (!field.Values || field.Values.length === 0))
        )) {
          hasIncompleteField = true
        }
      }

      if (this.descriptionIncomplete) {
        return this.stopSave()
      }

      try {
        const formCopy = JSON.parse(JSON.stringify(this.fields))
        const updatedFields = formCopy.map(i => {
          return i.map(x => {
            if (x.Type === 'select' && x.Values && typeof x.Values === 'object') {
              x.Values = x.Values.text
            } else if (x.Type === 'text' && x.Values && Array.isArray(x.Values) && x.Values.length > 0) {
              x.Values = x.Values[0]
            }
            return x
          })
        })

        let form = {
          Fields: updatedFields,
          CategoryIds: this.selectedCategory,
          ReferenceIds: this.referenceId,
          Descriptions: this.descriptions,
          BusinessUnitIds: this.selectedBu,
          CostCenterIds: this.selectedCc,
          ProgramBusinessUnitAndCostCenterIds: this.selectedBuAndCcPair,
          Amounts: this.splitAmounts,
          TransactionReconcileSplitItemIds: this.itemIds
        }

        if (this.selectedCardId) {
          // Defensive padding — every per-row array must have splitCounter entries or
          // Legacy's SaveTransactionFields (EvedPayCardsRepository.cs:3848) throws
          // IndexOutOfRange when it iterates Amounts.Count and accesses parallel arrays.
          // Photon-driven splits can outpace the emit chain that syncs these arrays back
          // up to Card-list, leaving shorter-than-expected lengths at save time.
          const padArray = (arr, len, fill) => {
            const out = Array.isArray(arr) ? arr.slice() : []
            while (out.length < len) {
              out.push(fill === undefined ? null : fill)
            }
            return out
          }
          const rowCount = this.splitCounter || 1
          const paddedSelectedBu = padArray(this.selectedBu, rowCount)
          const paddedSelectedCc = padArray(this.selectedCc, rowCount)
          const paddedSelectedBuAndCcPair = padArray(this.selectedBuAndCcPair, rowCount)
          const paddedSelectedCategory = padArray(this.selectedCategory, rowCount)
          const paddedReferenceId = padArray(this.referenceId, rowCount)
          const paddedDescriptions = padArray(this.descriptions, rowCount, '')
          const paddedSplitAmounts = padArray(this.splitAmounts, rowCount, 0)
          // Pad itemIds with the Empty Guid so SaveTransactionFields sees a
          // valid List<Guid> even when this.itemIds is shorter than rowCount
          // (or empty — e.g. a fresh SUBMIT-match reconcile where the rows
          // come from prefill and never had server-side ItemIds assigned).
          // Empty Guid hits the Guid.Empty branch in the BE loop and is
          // treated as a new split-item insert.
          // Without this pad, undefined entries serialize to JSON null and
          // either deserialize the whole property to null on the BE (NRE on
          // [i]) or raise an IndexOutOfRange when itemIds is shorter than
          // Amounts.Count.
          const EMPTY_GUID = '00000000-0000-0000-0000-000000000000'
          const paddedItemIds = padArray(this.itemIds, rowCount, EMPTY_GUID)
            .map(id => (id == null || id === '') ? EMPTY_GUID : id)

          // Sync the padded arrays into the Form payload too — the inner Form{...} object
          // is consumed by SaveTransactionFields which has the same parallel-indexing assumption.
          form.BusinessUnitIds = paddedSelectedBu
          form.CostCenterIds = paddedSelectedCc
          form.ProgramBusinessUnitAndCostCenterIds = paddedSelectedBuAndCcPair
          form.CategoryIds = paddedSelectedCategory
          form.ReferenceIds = paddedReferenceId
          form.Descriptions = paddedDescriptions
          form.Amounts = paddedSplitAmounts
          form.TransactionReconcileSplitItemIds = paddedItemIds

          const response = await this.api.post(this.api.$.evedpaycard.reconcile, {
            preventError: true,
            ...this.newReconcile,
            CardId: this.selectedCardId,
            TransactionId: this.selectedTransactionId,
            SupplierId: this.selectedSupplier && this.selectedSupplier.Value ? this.selectedSupplier.Value.VendorId : null,
            ProgramId: this.selectedProgram && this.selectedProgram.Id ? this.selectedProgram.Id : null,
            ReceiptFiles: this.filteredAttachments,
            AdditionalDocuments: this.additionalDocumentsFiles,
            Note: this.noteText,
            SplitAmounts: paddedSplitAmounts,
            BusinessUnitIds: paddedSelectedBu,
            CostCenterIds: paddedSelectedCc,
            BusinessUnitAndCostCenterIds: paddedSelectedBuAndCcPair,
            CategoryIds: paddedSelectedCategory,
            ReferenceIds: paddedReferenceId,
            Descriptions: paddedDescriptions,
            IsComplete: !hasIncompleteField,
            Form: form,
            FormKey: this.formKey
          })
          if (response.data) {
            return true
          } else {
            console.error('Error during the request. Response data is null.')
            this.$notifications.notify({ type: 'plain', icon: 'exclamation-circle', placement: { from: 'top', align: 'center' }, timeout: 0, message: 'An error occurred while saving. Please try again.', discard: 'Ok', goto: '' })
          }
        } else {
          console.error('Selected CardId is null or undefined.')
          this.$notifications.notify({ type: 'plain', icon: 'exclamation-circle', placement: { from: 'top', align: 'center' }, timeout: 0, message: 'An error occurred while saving. Please try again.', discard: 'Ok', goto: '' })
        }
      } catch (error) {
        console.error('Error during the request:', error)
        // PRODUCTDEV-5574 — surface the backend's blocked-reason payload (race where envelope
        // flipped to Posted/Exported while modal was open, or a ProgramId tamper).
        const blockedReason = error && error.response && error.response.data && error.response.data.reason
        const message = this.envelopeEditBlockedMessage(blockedReason) ||
          'An error occurred while saving. Please try again.'
        this.$notifications.notify({ type: 'plain', icon: 'exclamation-circle', placement: { from: 'top', align: 'center' }, timeout: 0, message, discard: 'Ok', goto: '' })
        this.stopSave()
      }
    },

    createEnvelope() {
      this.showCreateEnvelope = true
      window.history.pushState({}, '', '#/d/Programs/>Card/envelopes')
    },

    clearPollInterval() {
      if (this.pollInterval) {
        clearTimeout(this.pollInterval)
        this.pollInterval = null
      }
    },

    hasAccountPermission(permission) {
      if (this.$user && this.$user.$.userPermissions && this.$user.$.userPermissions.length !== 0) {
        return this.$user.$.userPermissions.includes(permission)
      }

      return false
    },

    closeAccount() {
      if (Object.keys(this.closeObj).length !== 0) {
        this.closeObj.divisionId = parseInt(this.account.Id)
        this.closeObj.funds = this.headerData.Available
        this.closeObj = {}
      }
    },

    cardActionDisabled(actionName, card) {
      return !!this.actionDisabledReason(actionName, card)
    },

    actionDisabledReason(actionName, card) {
      if (this.selectedRows.length > 1 && actionName === 'reconcile') {
        return 'You can only reconcile one transaction at a time.'
      }

      if (card && actionName === 'approveValidation' && card.PendingRequest > this.account.Available) {
        return 'There are insufficient funds in the account to complete this request.'
      }

      if (this.selectedRows.length > 0) {
        const firstCardId = this.selectedRows[0].data.CardId
        const programIds = Array.from(new Set(this.selectedRows.map(row => row && row.data.ProgramId !== null ? row.data.ProgramId : null).filter(id => id !== null)))

        if (programIds.length > 1 && actionName === 'createEnvelope') {
          return `Only transactions from the same ${this.programName.toLowerCase()} that are not already part of an envelope can be selected.`
        }

        for (var row of this.selectedRows) {
          if (row.data.TransactionStatus === 'Rejected' || row.data.TransactionStatus === 'Declined') {
            return 'Only transactions that are not Rejected or Declined can be selected.'
          }

          if (row.data.TransactionStatus === 'Pending' && actionName !== 'reconcile') {
            return 'Only transactions that are not Pending or Declined can be selected.'
          }

          if (row.data.EnvelopeNumber !== null && actionName === 'createEnvelope') {
            return 'Only transactions that are not already part of an envelope can be selected.'
          }

          if (row.data.CardId !== firstCardId) {
            return 'Only transactions from the same card that are not already part of an envelope can be selected.'
          }
        }
      }

      if (this.showEnvelopesTab) {
        if (this.selectedRows.length > 1 && actionName === 'envelope') {
          return 'You can only open one envelope at a time.'
        }
      }

      if (this.showCardsTab) {
        return cardMethods.actionDisabledReason.call(this, actionName)
      }

      if (this.selectedRows.length === 0 && !card) {
        return 'Please select a transaction.'
      }
    },

    singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value
    },

    exportEnvelope() {
      window.open(`${this.api.env}/evedpaycards/envelope/export/${this.selectedRows[0].data.Id}`, '_blank')
    },

    async createAPFile() {
      let payload = {
        envelopeIds: this.selectedRows.map(r => r.data.Id)
      }
      const response = await this.api.post(this.api.$.evedpaycard.createAPFile, payload)
      if (!response.data) {
        throw new Error('Error during the request')
      } else {
        this.refresh()
      }
    },

    async pushToAccountingSystem() {
      this.pushingToAccountingSystem = true

      const response = await this.api.put(`evedpaycards/envelope/push-to-accounting-system`, {
        envelopeIds: this.selectedRows.map(r => r.data.Id)
      })

      if (response.status !== 200) {
        this.pushingToAccountingSystem = false
        throw new Error('Error during the request')
      } else {
        this.pushingToAccountingSystem = false

        this.$notifications.notify({
          message: `The envelope(s) data has been sent to PSL+.`,
          type: 'info',
          placement: { from: 'top', align: 'center' }
        })

        this.refresh()
      }
    },

    envelopeActionDisabled(actionName) {
      return !!this.envelopeActionDisabledReason(actionName)
    },

    envelopeActionDisabledReason(actionName) {
      if (this.selectedRows.length === 0) {
        return 'Please select an envelope.'
      }
      if (actionName === 'exportEnvelope') {
        if (this.selectedRows.length !== 1) {
          return 'You can only export one envelope at a time.'
        } else if (this.selectedRows.length === 1) {
          if (this.selectedRows[0].data.EnvelopeStatus === 'Draft') {
            return 'You cannot export draft envelopes.'
          }
          if (this.rejectedStatuses.includes(this.selectedRows[0].data.EnvelopeStatus)) {
            return 'You cannot export declined envelopes.'
          }
        }
      }

      if (actionName === 'addTransactionNumber') {
        if (this.selectedRows.length === 0) {
          return 'Select an envelope.'
        }

        if (this.selectedRows.length === 1 && this.selectedRows[0].data.TransactionNo !== null) {
          return 'Envelope already has a transaction number.'
        }

        const hasTransactionNo = this.selectedRows.some(row => row.data.TransactionNo !== null)
        const hasOtherStatus = this.selectedRows.some(row =>
          row.data.EnvelopeStatus !== 'Exported - Approved' &&
          row.data.EnvelopeStatus !== 'Exported - Waiting Approval'
        )
        const firstApFileId = this.selectedRows[0].data.ApFileId
        const sameApFileId = this.selectedRows.every(row => row.data.ApFileId === firstApFileId)

        if (hasTransactionNo || hasOtherStatus || !sameApFileId) {
          return 'All selected envelopes must be in the same AP File and without a Transaction Number.'
        }
      }

      if (actionName === 'createAPFile') {
        if (this.selectedRows.length > 0) {
          for (let row of this.selectedRows) {
            if (row.data.APFile !== '' || row.data.EnvelopeStatus === 'Draft' || this.rejectedStatuses.includes(row.data.EnvelopeStatus)) {
              return 'You can only select envelopes that are not drafts, not declined, and do not have an AP file.'
            }
          }
          for (let row of this.selectedRows) {
            if (!row.data.CanGenerateAPFileWithoutApproval && row.data.EnvelopeStatus !== 'Open - Approved') {
              return 'One or more envelopes need to be approved first.'
            }
          }
        }
      }

      if (actionName === 'pushToAccountingSystemAction') {
        if (this.pushingToAccountingSystem) {
          return 'Pushing to PSL+...'
        }

        if (this.selectedRows.length > 0) {
          let accountSettings = this.accountSettings
          if (!accountSettings || !accountSettings.AccountingSystem || accountSettings.AccountingSystem.SyncEvedPayCardEnvelopes !== true) {
            return '"PSL+ Integration - Sync Envelope data" is unchecked.'
          }
        }

        for (let row of this.selectedRows) {
          if (!row.data.CardNumberKeyForAccountingSystem) {
            return 'Please first push card to PSL+ or assign the corresponding card number in PSL+ to the existing EVED card.'
          }
        }

        for (let row of this.selectedRows) {
          if (row.data.EnvelopeStatus === 'Draft' || this.rejectedStatuses.includes(row.data.EnvelopeStatus)) {
            return 'You can only select envelopes that are not drafts or declined.'
          }
        }
      }
    },

    requestPhysicalBatchActionDisabled(actionName) {
      return !!this.requestPhysicalBatchActionDisabledReason(actionName)
    },

    requestPhysicalBatchActionDisabledReason(actionName) {
      if (actionName === 'requestPhysicalBatch' && !this.hasPhysicalCards) {
        return 'No cards available for batch ordering.'
      }
    },

    async rowSelected(event) {
      if (typeof event === 'boolean') {
        this.selectedAll = event
      } else {
        this.selectedRows = event
        if (this.showTransactionsTab) {
          if (this.highlightedObjectId && this.highlightedObjectId.length > 0 && !this.showReconcile && this.selectedRows.length > 0) {
            this.highlightedObjectId = ''
            this.redrawRows()
          }
          await this.applyTransactionContext(this.selectedRows[0])
        } else if (this.showEnvelopesTab) {
          if (this.highlightedObjectId && this.highlightedObjectId.length > 0 && !this.showCreateEnvelope && this.selectedRows.length > 0) {
            this.highlightedObjectId = ''
            localStorage.setItem('row-highlight', '')
            this.$refs.grid.gridOptions.api.redrawRows()
          }
          if (this.selectedRows.length === 1) {
            this.envelope = this.selectedRows[0].data
            this.getApprovalUsersEnvelope(this.envelope.Id)
          }
        } else if (this.showCardsTab) {
          if (this.selectedRows.length > 0) {
            this.selectedObj = this.selectedRows.map(card => card.data)
            this.cardDivisionId = this.selectedObj[0].DivisionId
            if (this.selectedObj.every(card => card.CardStatus === 'Pending Approval')) {
              await this.getApprovalUsers(this.selectedObj[0].Id)
            } else {
              this.approvalUsersData = []
            }
          } else {
            this.selectedObj = []
          }
        }
      }
    },

    showModal(showReconcile) {
      if (!this.savePressed) {
        this.showReconcile = !showReconcile
        if (this.showReconcile) {
          this.highlightedObjectId = this.transaction.data.Id
        } else {
          this.redrawRows()
        }
        this.resetModalFields()
      }
    },

    resetFields() {
      this.savePressed = false
      this.selectedProgram = ''
      this.selectedSupplier = ''
      this.noteText = ''
      this.mediaFilesPath = ''
      this.filteredAttachments = []
      this.additionalDocumentsFiles = []
      this.fields = []
      this.formKey = ''
    },

    resetModalFields() {
      if (this.showReconcile) {
        if (this.$refs.reconcileComp) {
          this.$refs.reconcileComp.$refs.formRef.reset()
          this.resetValidation()
          this.resetFields()
        }
      } else {
        this.$refs.grid.onSelectAll(false)
        this.selectedRows = []
        this.transaction = {}
        this.approvalUsersData = []
        this.$refs.reconcileComp.$refs.formRef.reset()
        this.resetValidation()
        this.resetFields()
      }
    },

    updateMediaFilesPath(mediaFilesPath) {
      this.mediaFilesPath = mediaFilesPath
    },

    updateAttachmentsFiles(filteredAttachments) {
      this.filteredAttachments = filteredAttachments
    },

    // PRODUCTDEV-5772 — supporting documents from the reconcile modal (Card-list host).
    updateAdditionalDocuments(additionalDocuments) {
      this.additionalDocumentsFiles = additionalDocuments
    },

    handleFieldsUpdated(form) {
      this.fields = form.fields
      this.formKey = form.formKey
    },

    handleSplitAmounts(data) {
      this.splitAmounts = data
    },

    handleDescriptionText(data) {
      this.noteText = data.noteText
      this.requireReceiptDescription = data.requireReceiptDescription
    },

    handleUploadFinished(finished) {
      this.uploadFinished = finished
    },

    async saveAndReconcile() {
      if (!this.savePressed) {
        this.savePressed = true

        if (this.reconcileAction === 'view' && this.isUserAdmin) {
          if (this.filteredAttachments.length === 0) {
            this.$notifications.notify({
              type: 'info-warn',
              message: 'Receipt is required. Please upload at least one file.',
              placement: { from: 'top', align: 'center' }
            })
            return this.stopSave()
          }

          // PRODUCTDEV-5790 — also carry additional documents so a card admin can add/remove
          // them (not just the receipt) on a view-locked transaction. Backend keeps docs by Id
          // and soft-deletes any not in the list; additionalDocumentsFiles is populated from the
          // modal on open, so an untouched doc set round-trips unchanged.
          const mapFile = f => ({
            id: f.Id || '00000000-0000-0000-0000-000000000000',
            pathWithName: f.PathWithName,
            originalName: f.OriginalName,
            mediaFile: f.MediaFile,
            sizeBytes: f.SizeBytes,
            vendorId: f.VendorId
          })
          const payload = {
            transactionId: this.selectedTransactionId,
            receiptFiles: this.filteredAttachments.map(mapFile),
            additionalDocuments: this.additionalDocumentsFiles.map(mapFile)
          }

          try {
            await this.api.post(
              this.api.$.evedpaycard.updateReceipt,
              payload
            )
            this.$notifications.notify({
              type: 'info',
              message: 'Receipt updated successfully',
              placement: { from: 'top', align: 'center' }
            })
            this.savePressed = false
            this.closeReconcile({ userCancelled: false })
            this.resetModalFields()
          } catch (e) {
            console.error('Error while updating the receipt:', e)
          }
        } else {
          const r = await this.createReconcile()
          if (r) {
            EventBus.$emit('transaction-reconciled', this.transaction.data.Id)
            this.savePressed = false
            this.closeReconcile({ userCancelled: false })
            this.resetModalFields()
          }
        }
      }
    },

    handleReconcileCreated(data) {
      this.fields = data.fields ? data.fields : this.fields
      this.itemIds = data.itemIds
      this.splitCounter = data.splitCounter
      this.selectedSupplier = data.selectedSupplier
      this.selectedProgram = data.selectedProgram
      this.selectedBu = data.selectedBu
      this.selectedCc = data.selectedCc
      this.selectedBuAndCcPair = data.selectedBuAndCcPair
      this.selectedCategory = data.selectedCategory
      this.referenceId = data.referenceId
      this.descriptions = data.descriptions
    },

    createReconciliationEnvelope() {
      if (this.selectedRows.length === 0) {
        console.error('No data')
        return
      }
    },

    formatDate: function (date) {
      if (!date) {
        return 'N/A'
      }
      const momentDate = global.moment(date)
      const month = momentDate.format('MM')
      const year = momentDate.format('YY')
      return month + '/' + year
    },

    formatDateMMDDYYYY(date) {
      const momentDate = global.moment(date)
      const day = momentDate.format('DD')
      const month = momentDate.format('MM')
      const year = momentDate.format('YYYY')
      return month + '/' + day + '/' + year
    },

    showTransactions() {
      this.showTransactionsTab = true
      this.showEnvelopesTab = false
      this.showCardHistoryTab = false
      this.showCardsTab = false
      this.showAccountStatementsTab = false
      this.highlightedObjectId = ''
      this.selectedRows = []
      localStorage.setItem('row-highlight', '')
      this.envelope = {}
    },

    showEnvelopes() {
      this.selectedRows = []
      this.showTransactionsTab = false
      this.showEnvelopesTab = true
      this.showCardHistoryTab = false
      this.showCardsTab = false
      this.showAccountStatementsTab = false
      this.highlightedObjectId = ''
      this.highlightedObjectId = localStorage.getItem('row-highlight')
      this.cardApproval = false
      this.envelopeApproval = true
      this.envelope = {}
    },

    showCardHistory() {
      this.selectedRows = []
      this.showTransactionsTab = false
      this.showEnvelopesTab = false
      this.showCardHistoryTab = true
      this.showCardsTab = false
      this.showAccountStatementsTab = false
      this.highlightedObjectId = ''
      localStorage.setItem('row-highlight', '')
    },

    showCards() {
      this.selectedRows = []
      this.showTransactionsTab = false
      this.showEnvelopesTab = false
      this.showCardHistoryTab = false
      this.showCardsTab = true
      this.showAccountStatementsTab = false
      this.highlightedObjectId = ''
      localStorage.setItem('row-highlight', '')
      this.cardApproval = true
      this.envelopeApproval = false
    },

    showAccountStatements() {
      this.selectedRows = []
      this.showTransactionsTab = false
      this.showEnvelopesTab = false
      this.showCardHistoryTab = false
      this.showCardsTab = false
      this.showAccountStatementsTab = true
      this.highlightedObjectId = ''
      localStorage.setItem('row-highlight', '')
    },

    closeReconcile(opts) {
      // userCancelled defaults to true so existing X/cancel callers behave unchanged;
      // saveAndReconcile passes userCancelled:false so cleanupUnsavedReceipts doesn't
      // delete the ReceiptScan that was just linked. Everything else still runs —
      // the modal closes / state resets either way.
      var userCancelled = !opts || opts.userCancelled !== false
      if (userCancelled) {
        if (this.$refs.reconcileComp && typeof this.$refs.reconcileComp.cleanupUnsavedReceipts === 'function') {
          // Soft-delete any Platform receipt-scans uploaded in this session before tearing
          // down the modal — fire-and-forget so close stays responsive.
          this.$refs.reconcileComp.cleanupUnsavedReceipts()
        }
      } else if (this.$refs.reconcileComp && typeof this.$refs.reconcileComp.claimPendingFolderReceipts === 'function') {
        // PRODUCTDEV-5783 — reconcile saved: claim any receipt picked from the folder this
        // session (deferred FolderSaved → Matched) so it leaves the folder only on save.
        this.$refs.reconcileComp.claimPendingFolderReceipts()
      }
      this.showReconcile = false
      this.refresh()
      this.selectedRows = []
      this.transaction = {}
      this.approvalUsersData = []
      this.resetValidation()
      this.resetFields()
      // Strip receiptScanId from URL so a later reconcile opened from the
      // grid doesn't accidentally re-apply the just-matched scan's prefill.
      if (this.$route.query.receiptScanId) {
        const cleaned = { ...this.$route.query }
        delete cleaned.receiptScanId
        this.$router.replace({ query: cleaned }).catch(() => {})
      }
    },

    async refreshCards() {
      await this.getCards(this.selectedAccountId)
      if (this.showCardsTab) {
        this.refresh()
      }
    },

    async refreshCardWithDetails(cardId) {
      await this.getCardWithDetails(cardId)
      if (this.showCardsTab) {
        this.refresh()
      }
    },

    refresh() {
      this.$refs.grid.refreshGrid()
    },

    redrawRows() {
      this.$refs.grid.gridOptions.api.redrawRows()
    },

    redirectCardholder(accountId) {
      this.$router.push('/d/Programs/>Card/list?AccountId=' + accountId)
      this.selectedAccountId = this.$route.query.AccountId
      this.rememberLastAccount(accountId)
      this.getAccountData()
      this.getUserDivisions()
      this.getCards(this.selectedAccountId)
    },

    lastAccountStorageKey() {
      const userId = this.$user && this.$user.$ && this.$user.$.user && this.$user.$.user.UserID
      return userId ? 'evedpay:lastAccountId:' + userId : null
    },

    rememberLastAccount(accountId) {
      if (!accountId || !global.localStorage) return
      const key = this.lastAccountStorageKey()
      if (!key) return
      try {
        global.localStorage.setItem(key, accountId)
      } catch (e) {
        // localStorage may be unavailable (private mode); silently ignore.
      }
    },

    readLastAccount() {
      if (!global.localStorage) return null
      const key = this.lastAccountStorageKey()
      if (!key) return null
      try {
        return global.localStorage.getItem(key)
      } catch (e) {
        return null
      }
    },

    updateUrlBackToAccountPage() {
      window.history.pushState({}, '', '#/d/Programs/>Card/list?AccountId=' + this.selectedAccountId)
    },

    async handleTransaction(transaction) {
      await this.applyTransactionContext(transaction)
      this.showReconcile = true
      this.highlightedObjectId = this.transaction.data.Id
    },

    // PRODUCTDEV-5574 — shared transaction-context setup for every entry point that switches the
    // active transaction (row checkbox + toolbar Reconcile, transaction-number link, etc.). Resets
    // editAuth before fetching so the previous transaction's permissions can't leak into the new
    // row, and re-fetches editAuth whenever the new transaction is in an envelope so the toolbar
    // path also reaches the in-envelope edit gate instead of falling back to view-only.
    async applyTransactionContext(transaction) {
      this.transaction = transaction
      this.editAuth = null
      if (this.transaction && this.transaction.data) {
        this.selectedCardId = this.transaction.data.CardId
        this.selectedTransactionId = this.transaction.data.Id
        if (this.transaction.data.EnvelopeId && this.transaction.data.EnvelopeId !== '00000000-0000-0000-0000-000000000000') {
          await this.fetchEditAuth(this.transaction.data.Id)
        }
        // PRODUCTDEV-5783 — reset before the conditional reload so isUserInApprovalList()
        // reflects THIS transaction's envelope. getApprovalUsersEnvelope only runs for
        // waiting-approval envelopes, so without this a previously-opened approver envelope's
        // data could leak through and wrongly grant edit/receipt access. Mirrors Card-transactions.
        this.approvalUsersData = []
        if (this.waitingApprovalStatuses.includes(this.transaction.data.EnvelopeStatus)) {
          await this.getApprovalUsersEnvelope(this.transaction.data.EnvelopeId)
        }
        await this.handleReconcileAction(this.transaction)
      } else {
        this.reconcileAction = 'create'
      }
    },

    async handleReconcileAction(transaction) {
      const readonlyStatuses = ['In Envelope', 'Exported', 'Posted']
      const isInEnvelopeByTxStatus = readonlyStatuses.includes(transaction.data.TransactionStatus)
      if (transaction.data.ReconciliationStatus !== 'Open') {
        if (transaction.data.ReconciliationStatus === 'Coded') {
          if (transaction.data.EnvelopeStatus === 'Draft') {
            this.reconcileAction = 'edit'
          } else if (!isInEnvelopeByTxStatus || this.canEditInEnvelopeFromReconcileModal()) {
            this.reconcileAction = 'edit'
          } else {
            this.reconcileAction = 'view'
          }
        } else if (isInEnvelopeByTxStatus && this.canEditInEnvelopeFromReconcileModal()) {
          // PRODUCTDEV-5574 — Approved envelopes (e.g. Open - Approved) remain editable from the
          // Reconcile modal for authorized roles; per spec they are not editable from the envelope page.
          this.reconcileAction = 'edit'
        } else {
          this.reconcileAction = 'view'
        }
      } else if (isInEnvelopeByTxStatus) {
        if (transaction.data.EnvelopeStatus === 'Draft') {
          this.reconcileAction = 'edit'
        } else if (this.canEditInEnvelopeFromReconcileModal()) {
          this.reconcileAction = 'edit'
        } else {
          this.reconcileAction = 'view'
        }
      } else {
        this.reconcileAction = 'create'
      }
    },

    // PRODUCTDEV-5574 — fetch the backend's edit-authorization profile for an in-envelope
    // transaction. Mirrors Card-transactions/index.vue.
    async fetchEditAuth(transactionId) {
      try {
        const response = await this.api.get(this.api.$.evedpaycard.canEditInEnvelopeTransaction, {
          params: { transactionId }
        })
        this.editAuth = response.data || null
      } catch (error) {
        console.error('There was a problem fetching transaction edit authorization:', error)
        // Fail closed to view-only, but tell the user why so a transient can-edit
        // failure doesn't read as a silent permission downgrade.
        this.editAuth = null
        this.$notifications.notify({ type: 'plain', icon: 'exclamation-circle', placement: { from: 'top', align: 'center' }, timeout: 0, message: 'We could not verify your edit permissions for this transaction. Please refresh and try again.', discard: 'Ok', goto: '' })
      }
    },

    // PRODUCTDEV-5574 — the Reconcile modal does not grant edit access to a Declined-envelope
    // submitter who isn't also a card holder/admin/approver/global admin. That submitter-only
    // path is the envelope page's responsibility (CreateEnvelope.vue editEnvelope flow).
    canEditInEnvelopeFromReconcileModal() {
      // ASP.NET MVC's default JsonResult serializes property names as-is (PascalCase),
      // matching the convention used by other endpoints in this controller.
      if (!this.editAuth || !this.editAuth.CanEdit) return false
      return this.editAuth.IsCardHolder ||
             this.editAuth.IsCardAdmin ||
             this.editAuth.IsApprover ||
             this.editAuth.IsGlobalAdmin
    },

    envelopeEditBlockedMessage(reason) {
      switch (reason) {
        case 'EnvelopePostedOrExported':
          return 'This envelope has been posted or exported. Transactions in it can no longer be edited.'
        case 'NotAuthorized':
          return 'You do not have permission to edit this transaction.'
        case 'ProgramChangeNotAllowed':
          return `The ${(this.programName || 'department').toLowerCase()} cannot be changed while the transaction is assigned to an envelope.`
        case 'EnvelopeNotFound':
        case 'TransactionNotFound':
          return 'We could not verify this transaction\'s envelope. Please refresh and try again.'
        default:
          return null
      }
    },

    openReceiptUpload() {
      this.pendingReceiptFile = null
      this.showSubmitReceiptModal = true
    },

    triggerReceiptFileInput() {
      this.$refs.receiptUploadInput.click()
    },

    handleReceiptFileSelected(event) {
      const files = event.target.files
      if (!files || files.length === 0) {
        return
      }
      const file = files[0]

      // Mirror AddReceipt.vue:166-181 — the <input accept> attribute is a hint
      // only; users can bypass it via drag/drop or via mobile pickers. Enforce
      // here so the BE doesn't have to reject and the user gets useful copy.
      const ALLOWED = ['pdf', 'png', 'jpg', 'jpeg']
      const parts = file.name ? file.name.split('.') : []
      const extension = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : ''
      if (!ALLOWED.includes(extension)) {
        this.$notifications.notify({
          type: 'info-warn',
          message: 'Please upload a file with one of these extensions: .pdf, .png, .jpg, .jpeg',
          placement: { from: 'top', align: 'center' }
        })
        if (this.$refs.receiptUploadInput) {
          this.$refs.receiptUploadInput.value = ''
        }
        return
      }

      const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10 MB — matches AddReceipt.vue
      if (file.size >= MAX_FILE_SIZE) {
        this.$notifications.notify({
          type: 'info-warn',
          message: 'File is too large. Please upload a receipt smaller than 10 MB.',
          placement: { from: 'top', align: 'center' }
        })
        if (this.$refs.receiptUploadInput) {
          this.$refs.receiptUploadInput.value = ''
        }
        return
      }

      this.pendingReceiptFile = file
    },

    clearPendingReceiptFile() {
      this.pendingReceiptFile = null
      if (this.$refs.receiptUploadInput) {
        this.$refs.receiptUploadInput.value = ''
      }
    },

    formatFileSize(bytes) {
      if (!bytes) return ''
      if (bytes < 1024) return bytes + 'b'
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + 'Kb'
      return (bytes / (1024 * 1024)).toFixed(1) + 'Mb'
    },

    closeSubmitReceiptModal() {
      if (this.uploadingReceipt) return
      this.showSubmitReceiptModal = false
      this.pendingReceiptFile = null
      if (this.$refs.receiptUploadInput) {
        this.$refs.receiptUploadInput.value = ''
      }
    },

    async confirmSubmitReceipt() {
      if (!this.pendingReceiptFile) {
        return
      }

      // Canvas-compress images before either upload (PDFs pass through). Cuts
      // typical phone-camera receipts from ~3-6 MB to ~200-400 KB. Failure
      // mode is graceful — returns the original file untouched.
      const file = await compressReceiptImage(this.pendingReceiptFile)
      this.uploadingReceipt = true
      this.uploadProgressPct = 0
      this.pendingLegacyReceipt = null

      // Drive bar width AND % label off the same rAF loop so they tick together over 4s.
      // The promise it returns IS the gate — we only swap modals once the bar truly hits 100%.
      const barDuration = 4000
      const start = performance.now()
      const barComplete = new Promise(resolve => {
        const tick = (now) => {
          const pct = Math.min(100, Math.round(((now - start) / barDuration) * 100))
          this.uploadProgressPct = pct
          if (pct < 100) {
            this._uploadProgressRaf = requestAnimationFrame(tick)
          } else {
            this._uploadProgressRaf = null
            resolve()
          }
        }
        this._uploadProgressRaf = requestAnimationFrame(tick)
      })

      // Option D — Legacy upload first (sequential), Platform second. Without
      // this the matched reconcile saves with no TransactionFiles row, and
      // reopen-view crashes on Substring(0,-1) of an empty PathWithName.
      // Mirrors ReconcileTransaction.uploadNewReceipt's pattern. Runs in
      // parallel with the 4s bar — Legacy is fast (~1-2s) so it normally
      // completes long before the bar; if it doesn't, we still wait for the
      // bar to swap modals (Platform may also still be in flight).
      const legacyUrl = this.api && this.api.env ? this.api.env + this.api.$.evedpaycard.receipt : null
      const legacyToken = this.$user && this.$user.sessionSettings ? this.$user.sessionSettings.Token : ''
      const legacyPromise = legacyUrl
        ? (function (self) {
            var lf = new FormData()
            lf.append('attachment_upload', file)
            return self.api.post(legacyUrl, lf, {
              headers: { 'Authorization': 'Bearer ' + legacyToken, 'Content-Type': 'multipart/form-data' }
            }).then(function (resp) {
              var body = resp && resp.data
              if (typeof body === 'string') {
                try { body = JSON.parse(body) } catch (e) { body = null }
              }
              if (!body || !body.success || !body.path) return null
              var m = body.path.match(/(ClientData\/.*)/)
              var pathWithName = m && m[1] ? m[1] : body.path
              var mediaFile = body.file || pathWithName.split('/').pop()
              return {
                path: body.path,
                pathWithName: pathWithName,
                mediaFile: mediaFile,
                file: mediaFile,
                name: file.name,
                type: file.type || '',
                size: file.size || 0
              }
            }).catch(function (err) {
              console.warn('Legacy receipt upload failed at Dashboard SUBMIT:', err)
              return null
            })
          })(this)
        : Promise.resolve(null)

      const formData = new FormData()
      formData.append('file', file)

      const idempotencyKey = (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
        ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (Math.random() * 16) | 0
          var v = c === 'x' ? r : (r & 0x3) | 0x8
          return v.toString(16)
        })

      // Channel narrowing — the Open and Pending Transactions page binds to an
      // "account" which is a Division (legacy naming). Send its DivisionId so the
      // BE ranker scopes candidates to Programs in this Division. Omit when no
      // account is loaded (BE treats null as "no narrowing", current behavior).
      const channelDivisionId = this.account && this.account.DivisionId
        ? this.account.DivisionId
        : null
      const submitExtra = channelDivisionId != null
        ? { uploadContextLegacyDivisionId: channelDivisionId }
        : null

      // Kick off the upload now, but DON'T await it here. We always swap modals
      // when the bar finishes (4s) — the upload may complete before, during, or after.
      this.$notifications.notify({
        type: 'info',
        message: 'Scanning receipt...',
        placement: { from: 'top', align: 'center' }
      })
      const uploadPromise = receiptScansApi.submitReceipt(formData, idempotencyKey, submitExtra)

      try {
        // Wait for the bar to truly hit 100%, then swap modals immediately.
        await barComplete

        this.uploadingReceipt = false

        // Build a client-side objectURL from the file the user just picked so the
        // receipt is visible the instant the skeleton modal opens — no waiting on
        // the BE image fetch. URL is revoked on modal close (see watcher below).
        // We pass the MIME alongside so the modal renders <embed> for PDFs (an
        // <img> tag silently shows nothing for application/pdf bytes).
        if (this.candidateSelectorLocalImageUrl) {
          URL.revokeObjectURL(this.candidateSelectorLocalImageUrl)
        }
        this.candidateSelectorLocalImageUrl = URL.createObjectURL(file)
        this.candidateSelectorLocalImageType = file.type || null

        this.closeSubmitReceiptModal()

        // Open the Select Transaction modal in skeleton state. receiptScanId is
        // still null — handleReceiptScanStarted will set it + start the poller
        // once `uploadPromise` resolves. The image is already visible from the
        // local objectURL above.
        this.candidateSelectorReceiptId = null
        this.candidateSelectorCandidates = []
        this.candidateSelectorRowVersion = null
        this.candidateSelectorAutoLinked = false
        this.candidateSelectorAutoFill = null
        this.candidateSelectorLoading = true
        this.showCandidateSelector = true

        // Now wait for the upload itself. Stash Legacy metadata alongside so
        // handleMatchSelected can hand it to ReconcileTransaction via sessionStorage.
        const [data, legacyMeta] = await Promise.all([uploadPromise, legacyPromise])
        this.pendingLegacyReceipt = legacyMeta || null

        // User may have dismissed the skeleton modal mid-flight. handleReceiptScanStarted
        // hasn't fired yet so candidateSelectorReceiptId is still null and the close
        // handler couldn't dispose. Fire delete here with the freshly-returned id.
        if (!this.showCandidateSelector) {
          if (data && data.receiptScanId) {
            receiptScansApi.deleteReceipt(data.receiptScanId).catch(function (err) {
              console.warn('Receipt dispose on mid-upload dismiss failed (ignored):', err)
            })
          }
          return
        }

        if (data && data.receiptScanId) {
          // extended-bus.js auto-wraps payload as { target, data }; emit raw shape so listener's payload.data resolves to { receiptScanId, source }
          EventBus.$emit('receipt-scan-started', {
            receiptScanId: data.receiptScanId,
            source: 'webDashboard'
          })
          if (legacyUrl && !legacyMeta) {
            // Photon succeeded but the parallel Legacy attachment upload failed (see Option D
            // comment above). The reconcile match will still work on the Platform side, but the
            // legacy reopen-view will show no receipt image. Surface this clearly so the user can
            // cancel + retry instead of discovering the gap later.
            this.$notifications.notify({
              type: 'info-warn',
              message: "Receipt scanned, but it couldn't be attached to the transaction record. Match will still work, but the receipt won't appear on reopen. Cancel and retry if you need the attachment preserved.",
              placement: { from: 'top', align: 'center' }
            })
          }
          // Success case: no post-scan toast — the immediate "Scanning receipt..."
          // toast above signaled progress, and the candidate selector modal opening
          // is sufficient completion confirmation.
        }
      } catch (error) {
        // Upload failed — close whichever modal is still up.
        this.uploadingReceipt = false
        this.closeSubmitReceiptModal()

        // PRODUCTDEV-5851 — the image couldn't be scanned (e.g. dimensions out of range), but the
        // backend still persisted the receipt (ReadyForMatch, zero candidates) and returns 422 with
        // its receiptScanId. Silently drive the SAME post-scan flow (no error toast) so the user can
        // match manually or save it to their folder. Isolated to this one status — every other error
        // keeps its handling below.
        if (error.response && error.response.status === 422 && error.response.data && error.response.data.receiptScanId) {
          EventBus.$emit('receipt-scan-started', {
            receiptScanId: error.response.data.receiptScanId,
            source: 'webDashboard'
          })
          return
        }

        if (this.showCandidateSelector && this.candidateSelectorLoading && !this.candidateSelectorReceiptId) {
          this.showCandidateSelector = false
          this.candidateSelectorLoading = false
        }

        if (error.isPlatformSentinelError) {
          this.$notifications.notify({
            type: 'info-warn',
            message: 'Receipt capture is temporarily unavailable. Please try again later.',
            placement: { from: 'top', align: 'center' }
          })
          return
        }
        this.$notifications.notify({
          type: 'info-warn',
          message: 'Failed to upload receipt. Please try again.',
          placement: { from: 'top', align: 'center' }
        })
        console.error('Error uploading receipt:', error)
      } finally {
        if (this._uploadProgressRaf) {
          cancelAnimationFrame(this._uploadProgressRaf)
          this._uploadProgressRaf = null
        }
        this.uploadingReceipt = false
        this.uploadProgressPct = 0
      }
    },

    handleReceiptScanStarted (data) {
      const self = this
      const receiptScanId = data.receiptScanId

      if (this.activePoller) { this.activePoller.cancel() }

      // Open the Select Transaction modal IMMEDIATELY in skeleton-loading state
      // so the user sees the receipt image + shimmer placeholders while the
      // Photon scan polls in the background. The poller's onDone clears
      // `candidateSelectorLoading` and populates real candidates/autoFill.
      this.candidateSelectorReceiptId = receiptScanId
      this.candidateSelectorCandidates = []
      this.candidateSelectorRowVersion = null
      this.candidateSelectorAutoLinked = false
      this.candidateSelectorAutoFill = null
      this.candidateSelectorLoading = true
      this.showCandidateSelector = true

      const poller = createReceiptScanPoller({
        receiptScanId,
        contextHint: { source: data.source },
        onStateChange () {},
        onDone () {
          self.activePoller = null
          receiptScansApi.getStatus(receiptScanId)
            .then(function (statusData) {
              var candidates = (statusData && statusData.matchCandidates) || []

              // Auto-link only when exactly one candidate AND BE flagged it as a confident
              // match. Route straight to the transaction detail page with the receiptScanId
              // so ReconcileTransaction.tryApplyReceiptScanPrefill picks it up and applies
              // prefill per the Division's configured mode.
              if (candidates.length === 1 && statusData.autoLinked) {
                self.showCandidateSelector = false
                self.candidateSelectorLoading = false
                self.candidateSelectorReceiptId = null
                self.openMatchedReconcile(candidates[0].legacyTransactionId, receiptScanId)
                return
              }

              // Either real candidates OR zero candidates — keep the modal open so the user
              // can pick a match, ADD TO RECEIPT FOLDER deliberately, or CANCEL (which
              // soft-deletes via handleCandidateSelectorClose). Don't silently auto-park —
              // the user needs to see the receipt and decide.
              self.candidateSelectorReceiptId = receiptScanId
              self.candidateSelectorCandidates = candidates
              self.candidateSelectorRowVersion = statusData.rowVersion
              self.candidateSelectorAutoLinked = statusData.autoLinked || false
              self.candidateSelectorAutoFill = statusData.autoFill || null
              self.candidateSelectorLoading = false
              self.showCandidateSelector = true
            })
            .catch(function (err) {
              console.error('Error fetching receipt status:', err)
              self.showCandidateSelector = false
              self.candidateSelectorLoading = false
              self.$notifications.notify({
                type: 'danger',
                message: 'Failed to retrieve receipt details. Please try again.',
                placement: { from: 'top', align: 'center' }
              })
            })
        },
        onError (error) {
          self.activePoller = null
          // Scan failed/timed out — drop the skeleton modal so the user isn't stuck staring at it.
          self.showCandidateSelector = false
          self.candidateSelectorLoading = false
          if (error.type === 'unreachable' || error.type === 'timeout') {
            // Scan still in progress server-side; BE retry sweep continues
            // up to its wall-clock ceiling. The receipt isn't in the folder
            // yet, so don't navigate there — it would be empty.
            self.$notifications.notify({
              type: 'info',
              message: 'Scan is taking longer than expected. We\'ll keep working on it — check the Receipt Folder later.',
              placement: { from: 'top', align: 'center' }
            })
          } else if (error.type === 'scan_failed') {
            self.$notifications.notify({
              type: 'danger',
              message: 'Scan failed. Please try uploading the receipt again.',
              placement: { from: 'top', align: 'center' }
            })
          } else {
            self.$notifications.notify({
              type: 'danger',
              message: 'Error scanning receipt. Please try again.',
              placement: { from: 'top', align: 'center' }
            })
          }
        }
      })

      this.activePoller = poller
      poller.start()
    },

    // TODO(productdev-5606): mobile + folder callers may need same loading prop wiring

    handleMatchSelected (data) {
      // Clear receiptId BEFORE the modal's @close fires, otherwise
      // handleCandidateSelectorClose will fall through to dispose-on-cancel and
      // soft-delete the already-Matched receipt (BE returns 400 wrong_state).
      // (handleSaveToFolder below has the same pattern for the same reason.)
      this.candidateSelectorReceiptId = null
      this.showCandidateSelector = false
      // Open the desktop reconcile modal in-place with the matched tx data —
      // ReconcileTransaction will apply prefill from receiptScanId in the URL
      // and consume the stashed Legacy upload metadata for the file chip.
      this.openMatchedReconcile(data.legacyTransactionId, data.receiptScanId)
    },

    // Open the desktop reconcile modal for a transaction that was just matched
    // via the CandidateSelector. Used by both manual-pick (handleMatchSelected)
    // and auto-link (in handleReceiptScanStarted's onDone). Stashes the Legacy
    // upload metadata, pre-fetches the prefill (so the modal opens populated
    // instead of empty-then-populating), drops receiptScanId into the URL query
    // so ReconcileTransaction.tryApplyReceiptScanPrefill + consumeStashedLegacyReceipt
    // pick it up on mount, then fetches the tx data via the grid's existing
    // endpoint so handleTransaction can open the modal exactly like a row click.
    async openMatchedReconcile (legacyTransactionId, receiptScanId) {
      this.stashLegacyReceiptForReconcile(receiptScanId)

      try {
        await this.$router.replace({
          query: { ...this.$route.query, receiptScanId: receiptScanId }
        })
      } catch (e) {
        // NavigationDuplicated when the URL already carries this query — fine, ignore.
      }

      // Pre-fetch prefill in parallel with the tx fetch. Stash result so
      // ReconcileTransaction.tryApplyReceiptScanPrefill consumes it synchronously
      // on mount instead of doing its own network call (which would render the
      // modal empty for ~200-500ms then flash in the values). Promise.all gates
      // the modal open behind whichever fetch finishes last.
      const prefillP = receiptScansApi.getPrefill(receiptScanId)
        .then(function (data) {
          if (data) {
            try {
              global.sessionStorage.setItem(
                'receiptScanPrefill_' + receiptScanId,
                JSON.stringify(data)
              )
            } catch (e) {
              // sessionStorage disabled — Reconcile falls back to its own API call
            }
          }
        })
        .catch(function () {
          // Prefill fetch failed — Reconcile's tryApplyReceiptScanPrefill will retry
          // via the API path. Not fatal here.
        })

      const txP = this.api.forms.post(this.api.$.evedpaycard.transactions, {
        sort: 'TransactionStatus',
        dir: 'ASC',
        start: 0,
        limit: 1,
        isLiveGrid: true,
        filter: JSON.stringify({ Id: legacyTransactionId, searchTerm: '' })
      })

      try {
        const [, resp] = await Promise.all([prefillP, txP])
        const rows = resp && resp.data && resp.data.Data
        if (rows && rows.length > 0) {
          const tx = rows[0]
          await this.handleTransaction({
            data: {
              ...tx,
              merchant: tx.Merchant,
              amount: tx.Amount,
              date: tx.TransactionDate,
              status: tx.TransactionStatus,
              reconcileStatus: tx.ReconciliationStatus,
              id: tx.Id
            }
          })
        } else {
          this.$notifications.notify({
            type: 'warning',
            message: 'Could not open the matched transaction. Click it in the list to view.',
            placement: { from: 'top', align: 'center' }
          })
        }
      } catch (err) {
        console.error('Failed to load matched transaction for reconcile:', err)
        this.$notifications.notify({
          type: 'warning',
          message: 'Could not open the matched transaction. Click it in the list to view.',
          placement: { from: 'top', align: 'center' }
        })
      }
    },

    // Persist the Legacy upload metadata under a sessionStorage key that the
    // navigated-to ReconcileTransaction will read once on `created`. We use
    // sessionStorage rather than a Vuex store because the receipt-capture flow
    // doesn't have one and a query-string blob would be ugly + URL-length-bounded.
    // The receiving side deletes the entry after consuming it (one-shot).
    stashLegacyReceiptForReconcile (receiptScanId) {
      if (!receiptScanId || !this.pendingLegacyReceipt) return
      try {
        var key = 'receiptScanLegacyPath_' + receiptScanId
        global.sessionStorage.setItem(key, JSON.stringify(this.pendingLegacyReceipt))
      } catch (err) {
        // Storage quota / disabled / SSR — non-fatal, the reconcile just won't
        // populate the file. User can still save (banner / matched scan stays),
        // they just lose the reopen-view convenience.
        console.warn('Could not stash legacy receipt metadata:', err)
      }
    },

    handleSaveToFolder () {
      this.showCandidateSelector = false
      this.candidateSelectorReceiptId = null
      // CandidateSelector emits this event AND already shows the success toast itself —
      // don't double up here.
    },

    handleMatchAttempt () {
      // ed-modal.confirm() synchronously fires @close right after @confirm
      // (edModal/index.vue:161-163). Without this flag, handleCandidateSelectorClose
      // would treat the SUBMIT click as a cancel and DELETE the scan while the
      // match POST is still in flight — DELETE wins the race ~half the time, and
      // the match handler 404s because the scan is soft-deleted before
      // AuthorizeMutateAsync runs. The match success/error paths handle disposal.
      this.candidateSelectorMatching = true
    },

    handleMatchError () {
      // Match POST failed; ed-modal already auto-closed. The scan is alive in
      // ReadyForMatch but no longer reachable from any UI surface (folder hides
      // non-FolderSaved). Dispose it explicitly so it doesn't orphan.
      const idToDispose = this.candidateSelectorReceiptId
      this.candidateSelectorReceiptId = null
      this.candidateSelectorMatching = false
      if (idToDispose) {
        receiptScansApi.deleteReceipt(idToDispose).catch(function (err) {
          console.warn('Match-error scan dispose failed (ignored):', err)
        })
      }
    },

    handleCandidateSelectorClose () {
      const self = this
      // X / CANCEL dismiss = dispose. handleMatchSelected and handleSaveToFolder
      // both null candidateSelectorReceiptId BEFORE close fires, so the snapshot
      // below is non-null only on the true "user walked away" path. DELETE
      // /receipts/{id} soft-deletes from any status except Submitted (per the
      // ReceiptScan.SoftDelete invariant) and is idempotent, so it's safe whether
      // OCR finished or is still in flight.
      if (self.activePoller) { self.activePoller.cancel(); self.activePoller = null }
      // SUBMIT click triggers ed-modal's auto-close synchronously; the match POST
      // is still in flight. Skip dispose — handleMatchSelected/handleMatchError
      // will own cleanup.
      if (self.candidateSelectorMatching) {
        self.candidateSelectorMatching = false
        self.showCandidateSelector = false
        self.candidateSelectorLoading = false
        return
      }
      const idToDispose = self.candidateSelectorReceiptId
      self.showCandidateSelector = false
      self.candidateSelectorLoading = false
      self.candidateSelectorReceiptId = null
      if (idToDispose) {
        receiptScansApi.deleteReceipt(idToDispose).catch(function (err) {
          // 404 / wrong_state means a late match or save-to-folder won the race —
          // the scan moved on, nothing to dispose. Swallow.
          console.warn('Receipt dispose on cancel failed (ignored):', err)
        })
      }
    }
  },
  beforeDestroy() {
    this.isActive = false
    this.clearPollInterval()
    this.refreshScheduled = false
    if (this.activePoller) { this.activePoller.cancel(); this.activePoller = null }
    if (this.pendingReceiptObjectUrl) URL.revokeObjectURL(this.pendingReceiptObjectUrl)
  },

  deactivated() {
    this.isActive = false
    this.clearPollInterval()
    this.refreshScheduled = false
    if (this.activePoller) { this.activePoller.cancel(); this.activePoller = null }
  }
}
</script>

<style lang="scss" scoped>
 @import "./statuses.scss";
 @import "~@/assets/sass/_variables.scss";
  .content .title-nav {
    line-height: 5em;
    >>> {
      .container .tabs-area {
        border-left: 0;
        line-height: 1em;
      }

      .page-title {
        padding: 0;
      }
    }
  }

.overview {
  .overview-card {
    margin-top: 3px;
    margin-bottom: 15px;
    width: 100%;
    height: 100px;
    min-height: 0;
    border-radius: 3px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
    padding: 20px 16px 14px
  }
}

.prefunding-alert {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 9px 16px;
  margin: 10px 0;
  background-color: #E6F7FF;
  border: 1px solid #91D5FF;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.85);

  &__title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
  }

  &__body {
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
  }
}

.middleLine {
  border-left: 1px solid #eeeeee;
  min-height: 282px !important;
}

  .card-container {
    max-height: 390px;
    overflow-y: auto;
    display: grid;
    padding-top: 10px;
    padding-left: 10px;
    padding-bottom: 10px;
    margin-left: -10px;
    grid-template-columns: 24% 24% 24% 24%;
    column-gap: 1%;
    row-gap: 15px;
    background:
    /* Shadow Cover TOP */
    linear-gradient( white 30%, rgba(255, 255, 255, 0) ) center top,
    /* Shadow Cover BOTTOM */
    linear-gradient( rgba(255, 255, 255, 0), white 70% ) center bottom,
    /* Shadow TOP */
    radial-gradient( farthest-side at 50% 0, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0) ) center top,
    /* Shadow BOTTOM */
    radial-gradient( farthest-side at 50% 100%, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0) ) center bottom;
    background-repeat: no-repeat;
    background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
    background-attachment: local, local, scroll, scroll;

    >>> {
      .dawn-card.dawn-card {
        background: none;
        box-shadow: 0px 2px 5px 2px rgba(0, 0, 0, 0.1);
        float: none;
        width: auto;
        margin: 0;
        font-size: 14px;
        min-height: 20.5em;

        .dawn-card-top, .dawn-card-footer {
          display: none;
        }
      }

      // PRODUCTDEV-5908: a card spans one 24% column per area shown - the info column plus each pending
      // approval section (Funding / Refill Settings / Daily Spend Limit). cardClass emits the matching
      // cardApprovalSpan-N class so the card widens to hold them on one row (replaces the old
      // requestFunds / refillSettings rules, which only covered Funding + Refill).
      .dawn-card.cardApprovalSpan-2 {
        grid-column: auto / span 2;
      }

      .dawn-card.cardApprovalSpan-3 {
        grid-column: auto / span 3;
      }

      .dawn-card.cardApprovalSpan-4 {
        grid-column: auto / span 4;
      }
    }
  }


.card-container >>> .dawn-card-footer {
  visibility: hidden;
}

.soft-text {
  transform: rotate(.03deg);
}

.loading-text{
  text-align: center;
}

.custom-button {
  border: none;
  background-color: transparent;
  padding: 10px 20px;
  cursor: pointer;
  outline: none; 
}

.custom-button:hover {
  background-color: #f0f0f0; 
}

.custom-button.active {
  font-weight: bold;
}

.empty-holder {
  text-align: center;
  padding: 0 2rem;
  color: blue;

  i.fas {
    font-size: 1.7rem;
    height: 50px;
    width: 50px;
    padding-top: 11px;
    padding-left: 1px;
    background-color: #f2f2f2;
    border-radius: 50%;
    display: inline-block;
    color: #0099cc;
  }

  text-align: center;
  margin-top: 0px;
  color: #9c9c9c;
  font-size: 0.96em;
  font-weight: 600;

  span {
    text-align: left;
    display: inline-block;

    p {
      line-height: 1.1;
      display: block;
      text-align: center;

      &.bold {
        font-weight: 650;
      }

      &.light {
        font-size: 0.8rem;
        font-weight: 200;
      }
    }
  }
}

.account-header {
  display: flex;
  align-items: center;
}

.custom-ed-select {
  margin-bottom: 0;
  >>> {
    .dawnSelect {
      border-radius: 15px;
      margin-left: 10px;
      display: inline-block;
      vertical-align: middle;
      font-size: 8px;
      padding: 2px;
      border: 1px solid #808080;
      width: 150px;
    }

    .dawnSelect__tags {
      padding-left: 16px;
      background-color: transparent !important;
    }

    .dawnSelect__input {
      font-size: 12px;
      padding: 0;
      background-color: transparent;
      vertical-align: middle;
    }
  }
}

.grid >>> {
  .ag-row.row-highlight {
    @include theme {
      background-color: #DBE9F9;
    }
  }

  .label-bar {
    display: none;
  }

  .actions-bar {
    width:100%;
  }
}

.custom-col {
  width: 20%;
  float: left;
  padding: 0 15px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/index.vue